// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file devtool/v1/service.proto (package devtool.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Frequency } from "../emodel/v1/common_model_pb";
import { file_devtool_emodel_v1_common_model } from "../emodel/v1/common_model_pb";
import type { LiquidityCounterparty } from "../emodel/v1/liquidity_pfe_model_pb";
import { file_devtool_emodel_v1_liquidity_pfe_model } from "../emodel/v1/liquidity_pfe_model_pb";
import type { CalculatePowerMTMRequestSchema, CalculatePowerMTMResponseSchema } from "../emodel/v1/power_mtm_model_pb";
import { file_devtool_emodel_v1_power_mtm_model } from "../emodel/v1/power_mtm_model_pb";
import type { PFEScenarioSelector } from "../emodel/v1/risk_calc_engine_model_pb";
import { file_devtool_emodel_v1_risk_calc_engine_model } from "../emodel/v1/risk_calc_engine_model_pb";
import type { CalculateRiskRequest, CalculateRiskRequestSchema, CalculateRiskResponseSchema } from "../emodel/v1/risk_calc_engine_service_pb";
import { file_devtool_emodel_v1_risk_calc_engine_service } from "../emodel/v1/risk_calc_engine_service_pb";
import type { GetJobResultRequestSchema, GetJobResultResponseSchema, ListJobResultsRequestSchema, ListJobResultsResponseSchema } from "./job_result_pb";
import { file_devtool_v1_job_result } from "./job_result_pb";
import type { SimulatePFEOutputCSVs, SimulatePFEOutputCSVsForPortfolio } from "./model_pb";
import { file_devtool_v1_model } from "./model_pb";
import type { Deal, DealSettles, Order } from "../../external/v1/model_pb";
import { file_external_v1_model } from "../../external/v1/model_pb";
import type { DealMTM } from "../../external/v1/mtm_pb";
import { file_external_v1_mtm } from "../../external/v1/mtm_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Decimal } from "../../google/type/decimal_pb";
import { file_google_type_decimal } from "../../google/type/decimal_pb";
import type { BankTransactionDebitCreditType, BankTransactionUsageType } from "../../internalapi/v1/banking_model_pb";
import { file_internalapi_v1_banking_model } from "../../internalapi/v1/banking_model_pb";
import type { ListOrganizationContractsRequestSchema } from "../../internalapi/v1/contract_pb";
import { file_internalapi_v1_contract } from "../../internalapi/v1/contract_pb";
import type { BankAccount, EclearFeePattern, OrganizationOption, PhysicalContractDeliveryType, ReceivingPaymentBankAccount } from "../../internalapi/v1/contract_model_pb";
import { file_internalapi_v1_contract_model } from "../../internalapi/v1/contract_model_pb";
import type { AreaCode } from "../../types/v1/area_pb";
import { file_types_v1_area } from "../../types/v1/area_pb";
import type { CSVFileData } from "../../types/v1/csv_pb";
import { file_types_v1_csv } from "../../types/v1/csv_pb";
import type { BusinessDayType, DatePeriod } from "../../types/v1/date_pb";
import { file_types_v1_date } from "../../types/v1/date_pb";
import type { DealPosition, DeliveryHourType, DeliveryPeriodType, DeliveryType } from "../../types/v1/deal_pb";
import { file_types_v1_deal } from "../../types/v1/deal_pb";
import type { RequestSource } from "../../types/v1/request_source_pb";
import { file_types_v1_request_source } from "../../types/v1/request_source_pb";
import type { MTMPerspective, MTMUsageType } from "../../types/v1/risk_pb";
import { file_types_v1_risk } from "../../types/v1/risk_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file devtool/v1/service.proto.
 */
export const file_devtool_v1_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_devtool_emodel_v1_common_model, file_devtool_emodel_v1_liquidity_pfe_model, file_devtool_emodel_v1_power_mtm_model, file_devtool_emodel_v1_risk_calc_engine_model, file_devtool_emodel_v1_risk_calc_engine_service, file_devtool_v1_job_result, file_devtool_v1_model, file_external_v1_model, file_external_v1_mtm, file_google_protobuf_timestamp, file_google_type_date, file_google_type_decimal, file_internalapi_v1_banking_model, file_internalapi_v1_contract, file_internalapi_v1_contract_model, file_types_v1_area, file_types_v1_csv, file_types_v1_date, file_types_v1_deal, file_types_v1_request_source, file_types_v1_risk]);

/**
 * @generated from message devtool.v1.PreparePFECollateralRequest
 */
export type PreparePFECollateralRequest = Message<"devtool.v1.PreparePFECollateralRequest"> & {
  /**
   * @generated from field: string portfolio_id = 1;
   */
  portfolioId: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: google.type.Date base_date = 3;
   */
  baseDate?: Date;

  /**
   * @generated from field: optional uint32 evaluation_days = 4;
   */
  evaluationDays?: number;

  /**
   * The imported/edited positions. When present, the day-0 collateral is
   * priced from these (matching SimulatePFE) instead of the organization's
   * stored deals.
   *
   * @generated from field: repeated devtool.v1.PFESimPosition positions = 5;
   */
  positions: PFESimPosition[];
};

/**
 * Describes the message devtool.v1.PreparePFECollateralRequest.
 * Use `create(PreparePFECollateralRequestSchema)` to create a new message.
 */
export const PreparePFECollateralRequestSchema: GenMessage<PreparePFECollateralRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 0);

/**
 * @generated from message devtool.v1.PreparePFECollateralResponse
 */
export type PreparePFECollateralResponse = Message<"devtool.v1.PreparePFECollateralResponse"> & {
  /**
   * Day-0 collateral derived from the organization's unsettled deals' MTM
   * (unset when there are no deals to price).
   *
   * @generated from field: optional double current_collateral = 1;
   */
  currentCollateral?: number;

  /**
   * Margin-call threshold from the contract (unset for non-margin-call orgs).
   *
   * @generated from field: optional int64 threshold = 2;
   */
  threshold?: bigint;

  /**
   * Scheduled cash flows (deposits / margin-call settlements) as dated entries.
   *
   * @generated from field: repeated devtool.v1.PFECashIOEntry cash_io_schedules = 3;
   */
  cashIoSchedules: PFECashIOEntry[];

  /**
   * Current deposit balance (預託金総額, JPY). A separate concept from
   * current_collateral — not sent to eModel; used for the exposure-vs-deposit
   * comparison.
   *
   * @generated from field: optional int64 deposit = 4;
   */
  deposit?: bigint;

  /**
   * Whether collateral (VM / margin call) applies to this organization at
   * the base date. True for option-1 (FuturesBroker) orgs, false for
   * option-2 (DMA). Prefills the collateral on/off toggle on import.
   *
   * @generated from field: bool collateral_enabled = 5;
   */
  collateralEnabled: boolean;

  /**
   * The contract's 相互差し入れ flag; prefills the bilateral toggle on import.
   *
   * @generated from field: bool bilateral = 6;
   */
  bilateral: boolean;

  /**
   * The contract's Minimum Transfer Amounts (JPY): pay gates eClear-side
   * calls (eclear_mta), receive gates customer-side calls (mta).
   *
   * @generated from field: optional int64 mta_pay = 7;
   */
  mtaPay?: bigint;

  /**
   * @generated from field: optional int64 mta_receive = 8;
   */
  mtaReceive?: bigint;

  /**
   * The contract's margin-call payment lag (マージンコールサイト, business
   * days at the base date). Prefills the 支払サイト input on import.
   *
   * @generated from field: optional int32 payment_lag_days = 9;
   */
  paymentLagDays?: number;

  /**
   * The contract's margin-call evaluation frequency (マージンコール判定日).
   * Prefills the frequency select on import. Note: sending it back as an
   * override anchors the schedule to the base date instead of the contract's
   * weekday-based timing map.
   *
   * @generated from field: devtool.emodel.v1.Frequency margin_call_frequency = 10;
   */
  marginCallFrequency: Frequency;

  /**
   * ポートフォリオの与信枠（PhysicalLimit, JPY）。ハイブリッドスキームの
   * 保証枠入力の初期値として import 時に prefill する（0/未設定なら unset）。
   *
   * @generated from field: optional double standby_facility = 11;
   */
  standbyFacility?: number;
};

/**
 * Describes the message devtool.v1.PreparePFECollateralResponse.
 * Use `create(PreparePFECollateralResponseSchema)` to create a new message.
 */
export const PreparePFECollateralResponseSchema: GenMessage<PreparePFECollateralResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 1);

/**
 * @generated from message devtool.v1.PreparePFERequestRequest
 */
export type PreparePFERequestRequest = Message<"devtool.v1.PreparePFERequestRequest"> & {
  /**
   * @generated from field: string portfolio_id = 1;
   */
  portfolioId: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: google.type.Date base_date = 3;
   */
  baseDate?: Date;

  /**
   * @generated from field: optional uint32 evaluation_days = 4;
   */
  evaluationDays?: number;

  /**
   * @generated from field: optional uint32 evaluation_data_count = 5;
   */
  evaluationDataCount?: number;

  /**
   * @generated from field: repeated int32 selected_percentiles_bps = 6;
   */
  selectedPercentilesBps: number[];

  /**
   * When non-empty, PFETransactions are built from these hand-edited
   * positions instead of reading the portfolio's deals. daily_frames are
   * approximated per delivery day from hour_type (BASE=48, PEAK=24).
   *
   * @generated from field: repeated devtool.v1.PFESimPosition positions = 7;
   */
  positions: PFESimPosition[];

  /**
   * Optional MTM baseline override (indexed by evaluation day). Empty by
   * default; this is the manual MtmSeedSource path until daily_mtms is
   * computed server-side.
   *
   * @generated from field: repeated double daily_mtms = 8;
   */
  dailyMtms: number[];

  /**
   * Optional collateral overrides. When set, they adjust the collateral
   * post-process on top of the config derived from the organization contract
   * (dev-tool what-if for collateral sensitivity).
   *
   * @generated from field: devtool.v1.PFECollateralOverride collateral_override = 9;
   */
  collateralOverride?: PFECollateralOverride;

  /**
   * Optional visible cash flows (deposits / withdrawals / margin-call
   * settlements) placed on their dates. Merged into the computed cash IO as
   * optional schedules.
   *
   * @generated from field: repeated devtool.v1.PFECashIOEntry cash_io_schedules = 10;
   */
  cashIoSchedules: PFECashIOEntry[];

  /**
   * Optional scenario indices for the single-scenario trace decomposition
   * (pfe_scenario_decomposition), manual/diagnostic. Same inputs reproduce
   * the same scenarios, so indices picked from a prior run's
   * witness_scenario_indices stay valid.
   *
   * @generated from field: repeated int32 decomposition_scenario_indices = 11;
   */
  decompositionScenarioIndices: number[];

  /**
   * Optional semantic selectors for the trace decomposition (peak witness /
   * max / median / min peak). Combinable with the manual indices; both empty
   * = not computed.
   *
   * @generated from field: repeated devtool.emodel.v1.PFEScenarioSelector decomposition_scenario_selectors = 12;
   */
  decompositionScenarioSelectors: PFEScenarioSelector[];

  /**
   * Optional 品代支払日ルールの上書き。設定時は組織契約の payment_timings の
   * 代わりにこのルールから支払日を生成する（organization_id なしでも品代
   * ドロップが有効になる — Liquidity PFE Simulator の対EEXカード等）。
   *
   * @generated from field: devtool.v1.PFEPaymentTimingOverride payment_timing_override = 13;
   */
  paymentTimingOverride?: PFEPaymentTimingOverride;
};

/**
 * Describes the message devtool.v1.PreparePFERequestRequest.
 * Use `create(PreparePFERequestRequestSchema)` to create a new message.
 */
export const PreparePFERequestRequestSchema: GenMessage<PreparePFERequestRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 2);

/**
 * PFEPaymentTimingOverride は organization_contract の PaymentTiming と同形の
 * 支払日ルール（第N営業日 / 毎月N日の前後営業日補正 / 月末最終営業日）。
 *
 * @generated from message devtool.v1.PFEPaymentTimingOverride
 */
export type PFEPaymentTimingOverride = Message<"devtool.v1.PFEPaymentTimingOverride"> & {
  /**
   * 第N営業日の N、または毎月N日の N。LAST_BUSINESS_DAY では無視される。
   *
   * @generated from field: int32 due_day = 1;
   */
  dueDay: number;

  /**
   * @generated from field: types.v1.BusinessDayType business_day_type = 2;
   */
  businessDayType: BusinessDayType;
};

/**
 * Describes the message devtool.v1.PFEPaymentTimingOverride.
 * Use `create(PFEPaymentTimingOverrideSchema)` to create a new message.
 */
export const PFEPaymentTimingOverrideSchema: GenMessage<PFEPaymentTimingOverride> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 3);

/**
 * PFECollateralOverride carries dev-tool manual overrides for the PFE collateral
 * post-process. Unset fields keep the value derived from the organization
 * contract. current_collateral is always computed from the positions' MTM and
 * is not overridable.
 *
 * @generated from message devtool.v1.PFECollateralOverride
 */
export type PFECollateralOverride = Message<"devtool.v1.PFECollateralOverride"> & {
  /**
   * Overrides the margin-call threshold (JPY).
   *
   * @generated from field: optional int64 threshold = 2;
   */
  threshold?: bigint;

  /**
   * Turns the collateral post-process on/off. Unset = default (on only for
   * margin-call organizations); true = force on; false = force off.
   *
   * @generated from field: optional bool enabled = 3;
   */
  enabled?: boolean;

  /**
   * Runs the deposit-integrated bilateral model (相互差し入れ＋預託金統合,
   * Version 9.1) instead of the receive-only default. The backend translates
   * this into the eModel collateral exchange model (CSAType).
   *
   * @generated from field: bool bilateral = 4;
   */
  bilateral: boolean;

  /**
   * Minimum Transfer Amount, pay side (JPY): gates eClear-side margin calls.
   * Only used when bilateral = true; 0/unset disables the filter.
   *
   * @generated from field: optional double mta_pay = 5;
   */
  mtaPay?: number;

  /**
   * Minimum Transfer Amount, receive side (JPY): gates customer-side margin
   * calls. Only used when bilateral = true; 0/unset disables the filter.
   *
   * @generated from field: optional double mta_receive = 6;
   */
  mtaReceive?: number;

  /**
   * Initial Margin add-on (JPY) included in the customer's required margin.
   * Manual input for now. Only used when bilateral = true.
   *
   * @generated from field: optional double initial_margin = 7;
   */
  initialMargin?: number;

  /**
   * Base-date balance of customer deposits and guarantees held BY eClear
   * (eClear保有の顧客預託金＋保証残高, JPY). Only used when bilateral = true.
   *
   * @generated from field: optional double clearer_held_deposit = 8;
   */
  clearerHeldDeposit?: number;

  /**
   * Base-date balance of eClear deposits held BY the customer
   * (顧客保有のeClear預託金残高, JPY). Only used when bilateral = true.
   *
   * @generated from field: optional double customer_held_deposit = 9;
   */
  customerHeldDeposit?: number;

  /**
   * Payment lag in calendar days for margin-call settlement (マージンコール
   * サイト: call decision → cash arrival; business-day adjusted downstream).
   * Applies to both collateral models. Unset = contract-derived.
   *
   * @generated from field: optional int32 payment_lag_days = 10;
   */
  paymentLagDays?: number;

  /**
   * Margin call evaluation frequency (マージンコール判定日). When set, it
   * replaces the contract-derived schedule, including any pre-computed
   * timing map. FREQUENCY_UNSPECIFIED = contract-derived.
   *
   * @generated from field: devtool.emodel.v1.Frequency margin_call_frequency = 11;
   */
  marginCallFrequency: Frequency;

  /**
   * 統一エンジンの相互性: true = 片務（顧客のみ差し入れ）。Only used when
   * bilateral = true（bilateral が統一エンジンの選択、これが相互性の選択）。
   *
   * @generated from field: bool counterparty_only = 12;
   */
  counterpartyOnly: boolean;

  /**
   * ハイブリッドスキームの銀行保証枠（JPY）。顧客側コールの発動判定・請求額のみ
   * 相殺し、エクスポージャーには効かない。Only used when bilateral = true.
   *
   * @generated from field: optional double standby_facility = 13;
   */
  standbyFacility?: number;

  /**
   * 顧客預託金の余剰を返却するか。未指定/false = 返却しない（eClear 規約の既定:
   * 顧客側 0 フロア強制・返却経路なし）。true で従来挙動（相互=負コール返却、
   * 片務=withdrawal 返却）。Only used when bilateral = true.
   *
   * @generated from field: optional bool return_customer_collateral = 14;
   */
  returnCustomerCollateral?: boolean;
};

/**
 * Describes the message devtool.v1.PFECollateralOverride.
 * Use `create(PFECollateralOverrideSchema)` to create a new message.
 */
export const PFECollateralOverrideSchema: GenMessage<PFECollateralOverride> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 4);

/**
 * PFECashIOEntry is a single dated cash flow for the PFE collateral simulation.
 *
 * @generated from message devtool.v1.PFECashIOEntry
 */
export type PFECashIOEntry = Message<"devtool.v1.PFECashIOEntry"> & {
  /**
   * @generated from field: google.type.Date date = 1;
   */
  date?: Date;

  /**
   * Positive = cash in (reduces exposure), negative = cash out.
   *
   * @generated from field: double amount = 2;
   */
  amount: number;
};

/**
 * Describes the message devtool.v1.PFECashIOEntry.
 * Use `create(PFECashIOEntrySchema)` to create a new message.
 */
export const PFECashIOEntrySchema: GenMessage<PFECashIOEntry> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 5);

/**
 * PFESimPosition is one editable position row from the dev-tool PFE Simulator.
 *
 * @generated from message devtool.v1.PFESimPosition
 */
export type PFESimPosition = Message<"devtool.v1.PFESimPosition"> & {
  /**
   * eModel area code (1-9)
   *
   * @generated from field: int32 area_code = 1;
   */
  areaCode: number;

  /**
   * "BASE" | "PEAK"
   *
   * @generated from field: string hour_type = 2;
   */
  hourType: string;

  /**
   * "BG" | "JEPX" | "EEX"
   *
   * @generated from field: string delivery_type = 3;
   */
  deliveryType: string;

  /**
   * "Bid" | "Offer"
   *
   * @generated from field: string position = 4;
   */
  position: string;

  /**
   * positive magnitude; sign comes from position
   *
   * @generated from field: double volume_kw = 5;
   */
  volumeKw: number;

  /**
   * @generated from field: double unit_price_per_kwh = 6;
   */
  unitPricePerKwh: number;

  /**
   * inclusive
   *
   * @generated from field: google.type.Date delivery_start = 7;
   */
  deliveryStart?: Date;

  /**
   * inclusive
   *
   * @generated from field: google.type.Date delivery_end = 8;
   */
  deliveryEnd?: Date;

  /**
   * optional; unset when nothing settled
   *
   * @generated from field: google.type.Date settled_until = 9;
   */
  settledUntil?: Date;

  /**
   * Floating index code (e.g. "JERAGM_Wholesale_ChubuBase_Brent"). When set,
   * the synthesized transaction carries this floating index so the PFE computes
   * the floating leg (fixed_price = unit_price_per_kwh); empty = fixed BG only.
   *
   * @generated from field: string floating_index_code = 10;
   */
  floatingIndexCode: string;

  /**
   * Real delivery period type (month / multi_month / quarter / ...). When set,
   * the synthesized transaction uses it verbatim so the floating leg enumerates
   * the right months; UNSPECIFIED falls back to inferring from the delivery span.
   *
   * @generated from field: types.v1.DeliveryPeriodType delivery_period_type = 11;
   */
  deliveryPeriodType: DeliveryPeriodType;

  /**
   * 現先 (physical-futures) flag from the imported deal's eclear_delivery_type.
   * When true the synthesized transaction uses the EEX calendar for delivery
   * terms (the leg-level contagion rule) and is priced as a 現先 trade, so
   * hours/pricing match the real book. False for hand-entered / 現現 rows.
   *
   * @generated from field: bool is_physical_futures = 12;
   */
  isPhysicalFutures: boolean;

  /**
   * 約定日. Unset means the trade is not executed yet (a 新規注文), which
   * production never marks to market -- its risk reaches the PFE through the
   * scenario PnL, 品代 and IM only. When set, the row is a deal executed that
   * day: a same-day deal on the base date (marked only at EOD, so not in the
   * intraday credit path this simulator reproduces) and a previous deal before
   * it (always marked). Must not be after base_date.
   *
   * @generated from field: google.type.Date executed_date = 13;
   */
  executedDate?: Date;
};

/**
 * Describes the message devtool.v1.PFESimPosition.
 * Use `create(PFESimPositionSchema)` to create a new message.
 */
export const PFESimPositionSchema: GenMessage<PFESimPosition> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 6);

/**
 * @generated from message devtool.v1.HealthCheckRequest
 */
export type HealthCheckRequest = Message<"devtool.v1.HealthCheckRequest"> & {
};

/**
 * Describes the message devtool.v1.HealthCheckRequest.
 * Use `create(HealthCheckRequestSchema)` to create a new message.
 */
export const HealthCheckRequestSchema: GenMessage<HealthCheckRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 7);

/**
 * @generated from message devtool.v1.HealthCheckResponse
 */
export type HealthCheckResponse = Message<"devtool.v1.HealthCheckResponse"> & {
  /**
   * e.g. "v3.0.0" or commit hash
   *
   * @generated from field: string service_version = 1;
   */
  serviceVersion: string;
};

/**
 * Describes the message devtool.v1.HealthCheckResponse.
 * Use `create(HealthCheckResponseSchema)` to create a new message.
 */
export const HealthCheckResponseSchema: GenMessage<HealthCheckResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 8);

/**
 * @generated from message devtool.v1.StoreDealForDevToolRequest
 */
export type StoreDealForDevToolRequest = Message<"devtool.v1.StoreDealForDevToolRequest"> & {
  /**
   * @generated from field: external.v1.Deal deal = 1;
   */
  deal?: Deal;
};

/**
 * Describes the message devtool.v1.StoreDealForDevToolRequest.
 * Use `create(StoreDealForDevToolRequestSchema)` to create a new message.
 */
export const StoreDealForDevToolRequestSchema: GenMessage<StoreDealForDevToolRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 9);

/**
 * @generated from message devtool.v1.StoreDealForDevToolResponse
 */
export type StoreDealForDevToolResponse = Message<"devtool.v1.StoreDealForDevToolResponse"> & {
  /**
   * @generated from field: string deal_id = 1;
   */
  dealId: string;
};

/**
 * Describes the message devtool.v1.StoreDealForDevToolResponse.
 * Use `create(StoreDealForDevToolResponseSchema)` to create a new message.
 */
export const StoreDealForDevToolResponseSchema: GenMessage<StoreDealForDevToolResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 10);

/**
 * @generated from message devtool.v1.GetDealForDevToolRequest
 */
export type GetDealForDevToolRequest = Message<"devtool.v1.GetDealForDevToolRequest"> & {
  /**
   * default = current time
   *
   * @generated from field: optional google.protobuf.Timestamp reference_time = 1;
   */
  referenceTime?: Timestamp;

  /**
   * @generated from field: optional string portfolio_id = 2;
   */
  portfolioId?: string;

  /**
   * default = ""
   *
   * @generated from field: optional string organization_id = 3;
   */
  organizationId?: string;

  /**
   * default = CALCULATION_TARGET_TYPE_ALL
   *
   * @generated from field: devtool.v1.CalculationTargetType calculation_target_type = 4;
   */
  calculationTargetType: CalculationTargetType;

  /**
   * default = MTM_USAGE_TYPE_PER_ORGANIZATION
   *
   * @generated from field: optional types.v1.MTMUsageType mtm_usage_type = 5;
   */
  mtmUsageType?: MTMUsageType;
};

/**
 * Describes the message devtool.v1.GetDealForDevToolRequest.
 * Use `create(GetDealForDevToolRequestSchema)` to create a new message.
 */
export const GetDealForDevToolRequestSchema: GenMessage<GetDealForDevToolRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 11);

/**
 * @generated from message devtool.v1.GetDealForDevToolResponse
 */
export type GetDealForDevToolResponse = Message<"devtool.v1.GetDealForDevToolResponse"> & {
  /**
   * @generated from field: repeated external.v1.Deal deals = 1;
   */
  deals: Deal[];

  /**
   * @generated from field: repeated external.v1.DealMTM deal_mtms = 2;
   */
  dealMtms: DealMTM[];

  /**
   * @generated from field: repeated external.v1.DealSettles deal_settles = 3;
   */
  dealSettles: DealSettles[];
};

/**
 * Describes the message devtool.v1.GetDealForDevToolResponse.
 * Use `create(GetDealForDevToolResponseSchema)` to create a new message.
 */
export const GetDealForDevToolResponseSchema: GenMessage<GetDealForDevToolResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 12);

/**
 * @generated from message devtool.v1.PlatformDealIdWithPortfolioId
 */
export type PlatformDealIdWithPortfolioId = Message<"devtool.v1.PlatformDealIdWithPortfolioId"> & {
  /**
   * @generated from field: string platform_deal_id = 1;
   */
  platformDealId: string;

  /**
   * @generated from field: string portfolio_id = 2;
   */
  portfolioId: string;
};

/**
 * Describes the message devtool.v1.PlatformDealIdWithPortfolioId.
 * Use `create(PlatformDealIdWithPortfolioIdSchema)` to create a new message.
 */
export const PlatformDealIdWithPortfolioIdSchema: GenMessage<PlatformDealIdWithPortfolioId> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 13);

/**
 * @generated from message devtool.v1.SimulatePFEByOrderRequest
 */
export type SimulatePFEByOrderRequest = Message<"devtool.v1.SimulatePFEByOrderRequest"> & {
  /**
   * @generated from field: repeated devtool.v1.OrderWithNumber orders = 1;
   */
  orders: OrderWithNumber[];

  /**
   * @generated from field: repeated devtool.v1.OrderSimulationRelationWithNumber simulation_relations = 2;
   */
  simulationRelations: OrderSimulationRelationWithNumber[];

  /**
   * default = ""
   *
   * @generated from field: string portfolio_id = 3;
   */
  portfolioId: string;

  /**
   * default = ""
   *
   * @generated from field: string organization_id = 4;
   */
  organizationId: string;

  /**
   * default = ""
   *
   * @generated from field: string case_id = 5;
   */
  caseId: string;

  /**
   * default = false
   *
   * @generated from field: bool return_input_csv = 6;
   */
  returnInputCsv: boolean;

  /**
   * default = false
   *
   * @generated from field: bool return_snapshot = 10;
   */
  returnSnapshot: boolean;

  /**
   * default = true
   *
   * @generated from field: bool include_details = 7;
   */
  includeDetails: boolean;

  /**
   * default = false (legacy, kept for backwards compatibility)
   *
   * @generated from field: bool with_unit_price_buffer = 8;
   */
  withUnitPriceBuffer: boolean;

  /**
   * default = current time
   *
   * @generated from field: optional google.protobuf.Timestamp simulation_target_now = 9;
   */
  simulationTargetNow?: Timestamp;

  /**
   * default = false
   *
   * @generated from field: bool ignore_existing_deals = 11;
   */
  ignoreExistingDeals: boolean;

  /**
   * default = not set
   *
   * @generated from field: optional devtool.v1.OptionalSimulationInputs optional_simulation_inputs = 12;
   */
  optionalSimulationInputs?: OptionalSimulationInputs;

  /**
   * default = false, IM計算結果を含めるかどうか
   *
   * @generated from field: bool with_im_output = 13;
   */
  withImOutput: boolean;

  /**
   * Optional custom selected indices for PFE calculation (e.g., [0.99, 0.95, 0.90])
   *
   * @generated from field: repeated double selected_indices = 14;
   */
  selectedIndices: number[];

  /**
   * Optional evaluation days for PFE calculation (if not specified, auto-calculated from max transaction delivery end date + 1 month; minimum 60 days enforced)
   *
   * @generated from field: optional uint32 evaluation_days = 15;
   */
  evaluationDays?: number;

  /**
   * Optional evaluation data count for PFE calculation (default = 733)
   *
   * @generated from field: optional uint32 evaluation_data_count = 16;
   */
  evaluationDataCount?: number;

  /**
   * default = REQUEST_SOURCE_UNSPECIFIED
   *
   * @generated from field: types.v1.RequestSource request_source = 17;
   */
  requestSource: RequestSource;

  /**
   * バッファ値 (円/kWh)
   *
   * @generated from field: optional google.type.Decimal unit_price_buffer_value = 18;
   */
  unitPriceBufferValue?: Decimal;

  /**
   * バッファ適用モード（日中用: 新規のみ / リーブオーダー用: 全て）
   *
   * @generated from field: devtool.v1.UnitPriceBufferMode unit_price_buffer_mode = 19;
   */
  unitPriceBufferMode: UnitPriceBufferMode;

  /**
   * default = false, 個別保証発行用データを含めるかどうか
   *
   * @generated from field: bool with_individual_guarantee_output = 20;
   */
  withIndividualGuaranteeOutput: boolean;

  /**
   * default = false, emodel CalculateRiskRequest をレスポンスに含めるかどうか
   *
   * @generated from field: bool return_emodel_request = 21;
   */
  returnEmodelRequest: boolean;

  /**
   * 過去の特定時点でのシミュレーション用。指定時はDeal・預託金・入出金を指定時点のデータでフィルタする
   *
   * @generated from field: optional google.protobuf.Timestamp as_of_time = 22;
   */
  asOfTime?: Timestamp;

  /**
   * default = false, 当日約定を MTM 計算に含めるかどうか
   *
   * @generated from field: bool calculate_same_day_deal_mtm = 23;
   */
  calculateSameDayDealMtm: boolean;
};

/**
 * Describes the message devtool.v1.SimulatePFEByOrderRequest.
 * Use `create(SimulatePFEByOrderRequestSchema)` to create a new message.
 */
export const SimulatePFEByOrderRequestSchema: GenMessage<SimulatePFEByOrderRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 14);

/**
 * @generated from message devtool.v1.OrderWithNumber
 */
export type OrderWithNumber = Message<"devtool.v1.OrderWithNumber"> & {
  /**
   * @generated from field: uint32 order_number = 1;
   */
  orderNumber: number;

  /**
   * @generated from field: external.v1.Order order = 2;
   */
  order?: Order;

  /**
   * 相手方がVM相互差入対象か。未指定は false。
   *
   * 注文は未約定で相手方が deal_leg に存在しないため、相手方は呼び出し側が指定する。
   * 現先注文ではこの値は結果に影響しない(現先は取引種別で無条件に流動性軸へ入るため)。
   *
   * @generated from field: bool counterparty_is_bilateral_vm_exchange = 3;
   */
  counterpartyIsBilateralVmExchange: boolean;
};

/**
 * Describes the message devtool.v1.OrderWithNumber.
 * Use `create(OrderWithNumberSchema)` to create a new message.
 */
export const OrderWithNumberSchema: GenMessage<OrderWithNumber> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 15);

/**
 * @generated from message devtool.v1.OrderSimulationRelationWithNumber
 */
export type OrderSimulationRelationWithNumber = Message<"devtool.v1.OrderSimulationRelationWithNumber"> & {
  /**
   * @generated from field: uint32 relation_number = 1;
   */
  relationNumber: number;

  /**
   * @generated from field: repeated uint32 order_numbers = 2;
   */
  orderNumbers: number[];
};

/**
 * Describes the message devtool.v1.OrderSimulationRelationWithNumber.
 * Use `create(OrderSimulationRelationWithNumberSchema)` to create a new message.
 */
export const OrderSimulationRelationWithNumberSchema: GenMessage<OrderSimulationRelationWithNumber> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 16);

/**
 * @generated from message devtool.v1.OptionalSimulationInputs
 */
export type OptionalSimulationInputs = Message<"devtool.v1.OptionalSimulationInputs"> & {
  /**
   * Optional cash flow schedules for the organization
   *
   * @generated from field: repeated devtool.v1.OptionalSimulationInputsOrganizationCashIOSchedules organization_cash_io_schedules = 1;
   */
  organizationCashIoSchedules: OptionalSimulationInputsOrganizationCashIOSchedules[];

  /**
   * Optional historical EEX data set ID (UUID)
   *
   * @generated from field: optional string historical_eex_data_set_id = 2;
   */
  historicalEexDataSetId?: string;
};

/**
 * Describes the message devtool.v1.OptionalSimulationInputs.
 * Use `create(OptionalSimulationInputsSchema)` to create a new message.
 */
export const OptionalSimulationInputsSchema: GenMessage<OptionalSimulationInputs> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 17);

/**
 * @generated from message devtool.v1.OptionalSimulationInputsOrganizationCashIOSchedules
 */
export type OptionalSimulationInputsOrganizationCashIOSchedules = Message<"devtool.v1.OptionalSimulationInputsOrganizationCashIOSchedules"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Daily cash flow schedules for the organization
   *
   * @generated from field: repeated devtool.v1.OptionalSimulationInputsDailyCashIOSchedules daily_cash_io_schedules = 2;
   */
  dailyCashIoSchedules: OptionalSimulationInputsDailyCashIOSchedules[];
};

/**
 * Describes the message devtool.v1.OptionalSimulationInputsOrganizationCashIOSchedules.
 * Use `create(OptionalSimulationInputsOrganizationCashIOSchedulesSchema)` to create a new message.
 */
export const OptionalSimulationInputsOrganizationCashIOSchedulesSchema: GenMessage<OptionalSimulationInputsOrganizationCashIOSchedules> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 18);

/**
 * @generated from message devtool.v1.OptionalSimulationInputsDailyCashIOSchedules
 */
export type OptionalSimulationInputsDailyCashIOSchedules = Message<"devtool.v1.OptionalSimulationInputsDailyCashIOSchedules"> & {
  /**
   * Date for the cash flow schedule
   *
   * @generated from field: google.type.Date date = 1;
   */
  date?: Date;

  /**
   * Amount of cash flow
   *
   * @generated from field: google.type.Decimal amount = 2;
   */
  amount?: Decimal;
};

/**
 * Describes the message devtool.v1.OptionalSimulationInputsDailyCashIOSchedules.
 * Use `create(OptionalSimulationInputsDailyCashIOSchedulesSchema)` to create a new message.
 */
export const OptionalSimulationInputsDailyCashIOSchedulesSchema: GenMessage<OptionalSimulationInputsDailyCashIOSchedules> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 19);

/**
 * @generated from message devtool.v1.OrderFeeResult
 */
export type OrderFeeResult = Message<"devtool.v1.OrderFeeResult"> & {
  /**
   * @generated from field: uint32 order_number = 1;
   */
  orderNumber: number;

  /**
   * eClear手数料(円/kWh)。内訳の単価の和 (eclear_fee_rate + interest_charge + exchange_eclear_fee_rate (あれば)) を返す。
   * 両脚の kWh が違うスプレッドでは、この合算に kWh を掛けても請求額とは一致しない。請求額は内訳から求める。
   *
   * @generated from field: google.type.Decimal fee_per_kwh = 2;
   */
  feePerKwh?: Decimal;

  /**
   * 手数料を利用者に開示しない(無担保組織 / 与信枠・流動性枠の設定あり / 燃調インデックス指定)。
   * 非開示の理由によって表示は変わらないためフラグは1つ。値は非開示でも fee_per_kwh と内訳に入ったまま返す。
   *
   * @generated from field: bool is_fee_hidden = 3;
   */
  isFeeHidden: boolean;

  /**
   * 基準側の eClear 基本手数料(円/kWh)
   *
   * @generated from field: google.type.Decimal eclear_fee_rate = 4;
   */
  eclearFeeRate?: Decimal;

  /**
   * 基準側の金利コスト(円/kWh)
   *
   * @generated from field: google.type.Decimal interest_charge = 5;
   */
  interestCharge?: Decimal;

  /**
   * スプレッドの交換側の脚に掛ける eClear 手数料(円/kWh)。現先スプレッドで交換側にも請求するときだけ入る。未設定なら交換側には請求しない
   *
   * @generated from field: optional google.type.Decimal exchange_eclear_fee_rate = 6;
   */
  exchangeEclearFeeRate?: Decimal;
};

/**
 * Describes the message devtool.v1.OrderFeeResult.
 * Use `create(OrderFeeResultSchema)` to create a new message.
 */
export const OrderFeeResultSchema: GenMessage<OrderFeeResult> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 20);

/**
 * @generated from message devtool.v1.SimulatePFEByOrderResponse
 */
export type SimulatePFEByOrderResponse = Message<"devtool.v1.SimulatePFEByOrderResponse"> & {
  /**
   * @generated from field: repeated devtool.v1.SimulatePFEOutputsWithRelationNumber relation_outputs = 2;
   */
  relationOutputs: SimulatePFEOutputsWithRelationNumber[];
};

/**
 * Describes the message devtool.v1.SimulatePFEByOrderResponse.
 * Use `create(SimulatePFEByOrderResponseSchema)` to create a new message.
 */
export const SimulatePFEByOrderResponseSchema: GenMessage<SimulatePFEByOrderResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 21);

/**
 * @generated from message devtool.v1.BulkSimulatePFEByOrderCSVRequest
 */
export type BulkSimulatePFEByOrderCSVRequest = Message<"devtool.v1.BulkSimulatePFEByOrderCSVRequest"> & {
  /**
   * CSV file containing orders data
   *
   * @generated from field: types.v1.CSVFileData orders_csv = 1;
   */
  ordersCsv?: CSVFileData;

  /**
   * types.v1.CSVFileData simulation_relations_csv = 2; // 未対応
   *
   * default = current time
   *
   * @generated from field: optional google.protobuf.Timestamp simulation_target_now = 2;
   */
  simulationTargetNow?: Timestamp;

  /**
   * default = false 既存約定を無視するかどうか
   *
   * @generated from field: optional bool ignore_existing_deals = 3;
   */
  ignoreExistingDeals?: boolean;

  /**
   * Optional custom selected indices for PFE calculation (e.g., [0.99, 0.95, 0.90])
   *
   * @generated from field: repeated double selected_indices = 4;
   */
  selectedIndices: number[];

  /**
   * default = false OCCTOマスターチェックをスキップするかどうか
   *
   * @generated from field: optional bool skip_occto_master_check = 5;
   */
  skipOcctoMasterCheck?: boolean;

  /**
   * default = false 手数料計算をスキップするかどうか
   *
   * @generated from field: optional bool skip_fee_calculation = 6;
   */
  skipFeeCalculation?: boolean;
};

/**
 * Describes the message devtool.v1.BulkSimulatePFEByOrderCSVRequest.
 * Use `create(BulkSimulatePFEByOrderCSVRequestSchema)` to create a new message.
 */
export const BulkSimulatePFEByOrderCSVRequestSchema: GenMessage<BulkSimulatePFEByOrderCSVRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 22);

/**
 * @generated from message devtool.v1.BulkSimulatePFEByOrderCSVResponse
 */
export type BulkSimulatePFEByOrderCSVResponse = Message<"devtool.v1.BulkSimulatePFEByOrderCSVResponse"> & {
  /**
   * @generated from field: types.v1.CSVFileData output_csv = 1;
   */
  outputCsv?: CSVFileData;
};

/**
 * Describes the message devtool.v1.BulkSimulatePFEByOrderCSVResponse.
 * Use `create(BulkSimulatePFEByOrderCSVResponseSchema)` to create a new message.
 */
export const BulkSimulatePFEByOrderCSVResponseSchema: GenMessage<BulkSimulatePFEByOrderCSVResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 23);

/**
 * Streaming version of BulkSimulatePFEByOrderCSV response
 *
 * @generated from message devtool.v1.BulkSimulatePFEByOrderCSVStreamResponse
 */
export type BulkSimulatePFEByOrderCSVStreamResponse = Message<"devtool.v1.BulkSimulatePFEByOrderCSVStreamResponse"> & {
  /**
   * @generated from oneof devtool.v1.BulkSimulatePFEByOrderCSVStreamResponse.payload
   */
  payload: {
    /**
     * @generated from field: devtool.v1.BulkSimulatePFEByOrderCSVProgress progress = 1;
     */
    value: BulkSimulatePFEByOrderCSVProgress;
    case: "progress";
  } | {
    /**
     * @generated from field: devtool.v1.BulkSimulatePFEByOrderCSVPartialResult result = 2;
     */
    value: BulkSimulatePFEByOrderCSVPartialResult;
    case: "result";
  } | {
    /**
     * @generated from field: devtool.v1.BulkSimulatePFEByOrderCSVComplete complete = 3;
     */
    value: BulkSimulatePFEByOrderCSVComplete;
    case: "complete";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message devtool.v1.BulkSimulatePFEByOrderCSVStreamResponse.
 * Use `create(BulkSimulatePFEByOrderCSVStreamResponseSchema)` to create a new message.
 */
export const BulkSimulatePFEByOrderCSVStreamResponseSchema: GenMessage<BulkSimulatePFEByOrderCSVStreamResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 24);

/**
 * Progress information for streaming
 *
 * @generated from message devtool.v1.BulkSimulatePFEByOrderCSVProgress
 */
export type BulkSimulatePFEByOrderCSVProgress = Message<"devtool.v1.BulkSimulatePFEByOrderCSVProgress"> & {
  /**
   * Current processed count
   *
   * @generated from field: int32 current = 1;
   */
  current: number;

  /**
   * Total count
   *
   * @generated from field: int32 total = 2;
   */
  total: number;

  /**
   * e.g., "Processing 5/100 relations..."
   *
   * @generated from field: string message = 3;
   */
  message: string;
};

/**
 * Describes the message devtool.v1.BulkSimulatePFEByOrderCSVProgress.
 * Use `create(BulkSimulatePFEByOrderCSVProgressSchema)` to create a new message.
 */
export const BulkSimulatePFEByOrderCSVProgressSchema: GenMessage<BulkSimulatePFEByOrderCSVProgress> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 25);

/**
 * Partial result containing CSV rows for one relation
 *
 * @generated from message devtool.v1.BulkSimulatePFEByOrderCSVPartialResult
 */
export type BulkSimulatePFEByOrderCSVPartialResult = Message<"devtool.v1.BulkSimulatePFEByOrderCSVPartialResult"> & {
  /**
   * CSV row data (without header)
   *
   * @generated from field: bytes csv_rows = 1;
   */
  csvRows: Uint8Array;

  /**
   * Relation number for ordering
   *
   * @generated from field: int32 relation_number = 2;
   */
  relationNumber: number;
};

/**
 * Describes the message devtool.v1.BulkSimulatePFEByOrderCSVPartialResult.
 * Use `create(BulkSimulatePFEByOrderCSVPartialResultSchema)` to create a new message.
 */
export const BulkSimulatePFEByOrderCSVPartialResultSchema: GenMessage<BulkSimulatePFEByOrderCSVPartialResult> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 26);

/**
 * Completion notification
 *
 * @generated from message devtool.v1.BulkSimulatePFEByOrderCSVComplete
 */
export type BulkSimulatePFEByOrderCSVComplete = Message<"devtool.v1.BulkSimulatePFEByOrderCSVComplete"> & {
  /**
   * CSV header row
   *
   * @generated from field: bytes csv_header = 1;
   */
  csvHeader: Uint8Array;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;

  /**
   * Error message if not successful
   *
   * @generated from field: string error_message = 3;
   */
  errorMessage: string;
};

/**
 * Describes the message devtool.v1.BulkSimulatePFEByOrderCSVComplete.
 * Use `create(BulkSimulatePFEByOrderCSVCompleteSchema)` to create a new message.
 */
export const BulkSimulatePFEByOrderCSVCompleteSchema: GenMessage<BulkSimulatePFEByOrderCSVComplete> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 27);

/**
 * @generated from message devtool.v1.SimulatePFEOutputsWithRelationNumber
 */
export type SimulatePFEOutputsWithRelationNumber = Message<"devtool.v1.SimulatePFEOutputsWithRelationNumber"> & {
  /**
   * @generated from field: uint32 relation_number = 1;
   */
  relationNumber: number;

  /**
   * @generated from field: repeated devtool.v1.OrderWithNumber orders = 2;
   */
  orders: OrderWithNumber[];

  /**
   * results of credit risk check
   *
   * @generated from field: devtool.v1.CheckCreditRiskResults check_credit_risk_results = 3;
   */
  checkCreditRiskResults?: CheckCreditRiskResults;

  /**
   * output CSVs for each calculation target type. return only if request.include_details is true.
   *
   * @generated from field: repeated devtool.v1.SimulatePFEOutputCSVsByCalculationTargetType output_csvs = 4;
   */
  outputCsvs: SimulatePFEOutputCSVsByCalculationTargetType[];

  /**
   * fee calculation results for each order
   *
   * @generated from field: repeated devtool.v1.OrderFeeResult order_fees = 5;
   */
  orderFees: OrderFeeResult[];

  /**
   * unit price buffer (円/kWh) for the orders
   *
   * @generated from field: google.type.Decimal buffer_price = 6;
   */
  bufferPrice?: Decimal;

  /**
   * optional outputs
   *
   * @generated from field: optional devtool.v1.SimulatePFEOutputsWithRelationNumber.OptionalSimulationOutputs optional_simulation_outputs = 7;
   */
  optionalSimulationOutputs?: SimulatePFEOutputsWithRelationNumber_OptionalSimulationOutputs;

  /**
   * Percentiles used for PFE calculation (e.g., [0.99, 0.95, 0.90])
   *
   * @generated from field: repeated double selected_indices = 8;
   */
  selectedIndices: number[];

  /**
   * emodel CalculateRiskRequest per calculation target (only included if return_emodel_request is true)
   *
   * @generated from field: repeated devtool.v1.EmodelCalculateRiskRequestByTarget emodel_requests = 9;
   */
  emodelRequests: EmodelCalculateRiskRequestByTarget[];
};

/**
 * Describes the message devtool.v1.SimulatePFEOutputsWithRelationNumber.
 * Use `create(SimulatePFEOutputsWithRelationNumberSchema)` to create a new message.
 */
export const SimulatePFEOutputsWithRelationNumberSchema: GenMessage<SimulatePFEOutputsWithRelationNumber> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 28);

/**
 * @generated from message devtool.v1.SimulatePFEOutputsWithRelationNumber.OptionalSimulationOutputs
 */
export type SimulatePFEOutputsWithRelationNumber_OptionalSimulationOutputs = Message<"devtool.v1.SimulatePFEOutputsWithRelationNumber.OptionalSimulationOutputs"> & {
  /**
   * IM calculation results (only included if with_im_output is true)
   *
   * @generated from field: repeated devtool.v1.SimulatePFEOutputsWithRelationNumber.OptionalSimulationOutputs.IMOutput im_outputs = 1;
   */
  imOutputs: SimulatePFEOutputsWithRelationNumber_OptionalSimulationOutputs_IMOutput[];
};

/**
 * Describes the message devtool.v1.SimulatePFEOutputsWithRelationNumber.OptionalSimulationOutputs.
 * Use `create(SimulatePFEOutputsWithRelationNumber_OptionalSimulationOutputsSchema)` to create a new message.
 */
export const SimulatePFEOutputsWithRelationNumber_OptionalSimulationOutputsSchema: GenMessage<SimulatePFEOutputsWithRelationNumber_OptionalSimulationOutputs> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 28, 0);

/**
 * @generated from message devtool.v1.SimulatePFEOutputsWithRelationNumber.OptionalSimulationOutputs.IMOutput
 */
export type SimulatePFEOutputsWithRelationNumber_OptionalSimulationOutputs_IMOutput = Message<"devtool.v1.SimulatePFEOutputsWithRelationNumber.OptionalSimulationOutputs.IMOutput"> & {
  /**
   * IM number
   *
   * @generated from field: uint32 im_number = 1;
   */
  imNumber: number;

  /**
   * IM amount (in decimal format)
   *
   * @generated from field: google.type.Decimal im_amount = 2;
   */
  imAmount?: Decimal;

  /**
   * Calculation target type (all, physical_futures)
   *
   * @generated from field: devtool.v1.CalculationTargetType calculation_target_type = 3;
   */
  calculationTargetType: CalculationTargetType;

  /**
   * SPAN V2 API request JSON
   *
   * @generated from field: optional string request_json = 5;
   */
  requestJson?: string;

  /**
   * SPAN V2 API response JSON
   *
   * @generated from field: optional string response_json = 6;
   */
  responseJson?: string;
};

/**
 * Describes the message devtool.v1.SimulatePFEOutputsWithRelationNumber.OptionalSimulationOutputs.IMOutput.
 * Use `create(SimulatePFEOutputsWithRelationNumber_OptionalSimulationOutputs_IMOutputSchema)` to create a new message.
 */
export const SimulatePFEOutputsWithRelationNumber_OptionalSimulationOutputs_IMOutputSchema: GenMessage<SimulatePFEOutputsWithRelationNumber_OptionalSimulationOutputs_IMOutput> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 28, 0, 0);

/**
 * @generated from message devtool.v1.EmodelCalculateRiskRequestByTarget
 */
export type EmodelCalculateRiskRequestByTarget = Message<"devtool.v1.EmodelCalculateRiskRequestByTarget"> & {
  /**
   * @generated from field: devtool.v1.CalculationTargetType calculation_target_type = 1;
   */
  calculationTargetType: CalculationTargetType;

  /**
   * @generated from field: devtool.emodel.v1.CalculateRiskRequest calculate_risk_request = 2;
   */
  calculateRiskRequest?: CalculateRiskRequest;
};

/**
 * Describes the message devtool.v1.EmodelCalculateRiskRequestByTarget.
 * Use `create(EmodelCalculateRiskRequestByTargetSchema)` to create a new message.
 */
export const EmodelCalculateRiskRequestByTargetSchema: GenMessage<EmodelCalculateRiskRequestByTarget> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 29);

/**
 * @generated from message devtool.v1.SimulatePFEOutputCSVsByCalculationTargetType
 */
export type SimulatePFEOutputCSVsByCalculationTargetType = Message<"devtool.v1.SimulatePFEOutputCSVsByCalculationTargetType"> & {
  /**
   * calculation target type (all, physical_futures)
   *
   * @generated from field: devtool.v1.CalculationTargetType calculation_target_type = 1;
   */
  calculationTargetType: CalculationTargetType;

  /**
   * output CSVs for the specified calculation target type
   *
   * @generated from field: devtool.v1.SimulatePFEOutputCSVs output_csvs = 2;
   */
  outputCsvs?: SimulatePFEOutputCSVs;
};

/**
 * Describes the message devtool.v1.SimulatePFEOutputCSVsByCalculationTargetType.
 * Use `create(SimulatePFEOutputCSVsByCalculationTargetTypeSchema)` to create a new message.
 */
export const SimulatePFEOutputCSVsByCalculationTargetTypeSchema: GenMessage<SimulatePFEOutputCSVsByCalculationTargetType> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 30);

/**
 * @generated from message devtool.v1.CheckCreditRiskResults
 */
export type CheckCreditRiskResults = Message<"devtool.v1.CheckCreditRiskResults"> & {
  /**
   * true if order is allowed, false if rejected
   *
   * @generated from field: bool overall_allowed = 1;
   */
  overallAllowed: boolean;

  /**
   * results for all calculation target types
   *
   * @generated from field: devtool.v1.CheckCreditRiskResultByTarget all_result = 2;
   */
  allResult?: CheckCreditRiskResultByTarget;

  /**
   * results for physical futures calculation target type
   *
   * @generated from field: devtool.v1.CheckCreditRiskResultByTarget physical_futures_result = 3;
   */
  physicalFuturesResult?: CheckCreditRiskResultByTarget;

  /**
   * @generated from field: uint64 max_risk_amount = 4;
   */
  maxRiskAmount: bigint;

  /**
   * @generated from field: uint64 max_limit_amount = 5;
   */
  maxLimitAmount: bigint;

  /**
   * @generated from field: uint64 max_margin_call_amount = 6;
   */
  maxMarginCallAmount: bigint;

  /**
   * threshold amount in decimal format
   *
   * @generated from field: uint64 threshold_amount = 7;
   */
  thresholdAmount: bigint;

  /**
   * collateral amount in decimal format
   *
   * @generated from field: uint64 collateral_amount = 8;
   */
  collateralAmount: bigint;

  /**
   * surplus amount in decimal format
   *
   * @generated from field: int64 surplus_amount = 9;
   */
  surplusAmount: bigint;

  /**
   * @generated from field: string failure_reason = 10;
   */
  failureReason: string;

  /**
   * maximum required margin amount in decimal format
   *
   * @generated from field: uint64 max_required_margin = 11;
   */
  maxRequiredMargin: bigint;

  /**
   * days until first margin call payment
   *
   * @generated from field: optional uint32 first_margin_call_payment_days = 12;
   */
  firstMarginCallPaymentDays?: number;

  /**
   * maximum PFE value (raw percentile, can be negative) in decimal format
   *
   * @generated from field: int64 max_pfe = 13;
   */
  maxPfe: bigint;

  /**
   * maximum initial margin in decimal format
   *
   * @generated from field: uint64 max_initial_margin = 14;
   */
  maxInitialMargin: bigint;

  /**
   * maximum current collateral in decimal format (0 for Option2)
   *
   * @generated from field: uint64 max_current_collateral = 15;
   */
  maxCurrentCollateral: bigint;

  /**
   * breakdown data for individual guarantee issuance
   *
   * @generated from field: devtool.v1.IndividualGuaranteeIssuanceBreakdown individual_guarantee_issuance_breakdown = 16;
   */
  individualGuaranteeIssuanceBreakdown?: IndividualGuaranteeIssuanceBreakdown;

  /**
   * reference data for individual guarantee issuance
   *
   * @generated from field: devtool.v1.IndividualGuaranteeIssuanceReference individual_guarantee_issuance_reference = 17;
   */
  individualGuaranteeIssuanceReference?: IndividualGuaranteeIssuanceReference;

  /**
   * maximum floating PFE value (combined PFE - power-only PFE) in decimal format
   *
   * @generated from field: int64 max_floating_pfe = 18;
   */
  maxFloatingPfe: bigint;

  /**
   * maximum floating initial margin in decimal format
   *
   * @generated from field: uint64 max_floating_im = 19;
   */
  maxFloatingIm: bigint;

  /**
   * maximum-risk target MTM(day0), signed to support negative mark-to-market
   *
   * @generated from field: int64 max_mtm = 20;
   */
  maxMtm: bigint;
};

/**
 * Describes the message devtool.v1.CheckCreditRiskResults.
 * Use `create(CheckCreditRiskResultsSchema)` to create a new message.
 */
export const CheckCreditRiskResultsSchema: GenMessage<CheckCreditRiskResults> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 31);

/**
 * @generated from message devtool.v1.IndividualGuaranteeIssuanceBreakdown
 */
export type IndividualGuaranteeIssuanceBreakdown = Message<"devtool.v1.IndividualGuaranteeIssuanceBreakdown"> & {
  /**
   * MTM_PD: Sum of MTM price differences
   *
   * @generated from field: int64 mtm_pd = 1;
   */
  mtmPd: bigint;

  /**
   * MTM_GOODS: Sum of MTM goods
   *
   * @generated from field: int64 mtm_goods = 2;
   */
  mtmGoods: bigint;

  /**
   * IM: Initial Margin
   *
   * @generated from field: uint64 im = 3;
   */
  im: bigint;

  /**
   * 1M60%_PD: SimPeak1M at 60th percentile
   *
   * @generated from field: int64 sim_peak_1m_60 = 4;
   */
  simPeak1m60: bigint;

  /**
   * 1M_GOODS: MaxStackingPowerCost1m
   *
   * @generated from field: int64 goods_1m = 5;
   */
  goods1m: bigint;

  /**
   * PE(2M99%): SimPeak2M at 99th percentile
   *
   * @generated from field: int64 pe_2m_99 = 6;
   */
  pe2m99: bigint;
};

/**
 * Describes the message devtool.v1.IndividualGuaranteeIssuanceBreakdown.
 * Use `create(IndividualGuaranteeIssuanceBreakdownSchema)` to create a new message.
 */
export const IndividualGuaranteeIssuanceBreakdownSchema: GenMessage<IndividualGuaranteeIssuanceBreakdown> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 32);

/**
 * @generated from message devtool.v1.IndividualGuaranteeIssuanceReference
 */
export type IndividualGuaranteeIssuanceReference = Message<"devtool.v1.IndividualGuaranteeIssuanceReference"> & {
  /**
   * eClear調達銀行保証(発行済) - placeholder/dummy
   *
   * @generated from field: int64 eclear_bg_issued = 1;
   */
  eclearBgIssued: bigint;

  /**
   * eClear調達銀行保証(極度) - placeholder/dummy
   *
   * @generated from field: int64 eclear_bg_limit = 2;
   */
  eclearBgLimit: bigint;

  /**
   * 利用者差入担保(当初預託金) = MAX(deposit - variationMargin, 0)
   *
   * @generated from field: int64 initial_deposit = 3;
   */
  initialDeposit: bigint;

  /**
   * 利用者差入担保(変動証拠金) = MIN(deposit, MAX(MTM, 0))
   *
   * @generated from field: int64 variation_margin = 4;
   */
  variationMargin: bigint;

  /**
   * 預託金総額
   *
   * @generated from field: int64 deposit_total = 5;
   */
  depositTotal: bigint;
};

/**
 * Describes the message devtool.v1.IndividualGuaranteeIssuanceReference.
 * Use `create(IndividualGuaranteeIssuanceReferenceSchema)` to create a new message.
 */
export const IndividualGuaranteeIssuanceReferenceSchema: GenMessage<IndividualGuaranteeIssuanceReference> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 33);

/**
 * @generated from message devtool.v1.CheckCreditRiskResultByTarget
 */
export type CheckCreditRiskResultByTarget = Message<"devtool.v1.CheckCreditRiskResultByTarget"> & {
  /**
   * calculation target type (all, physical_futures)
   *
   * @generated from field: devtool.v1.CalculationTargetType target = 1;
   */
  target: CalculationTargetType;

  /**
   * true if order is allowed, false if rejected
   *
   * @generated from field: bool is_allowed = 2;
   */
  isAllowed: boolean;

  /**
   * risk amount in decimal format
   *
   * @generated from field: uint64 risk_amount = 3;
   */
  riskAmount: bigint;

  /**
   * limit amount in decimal format
   *
   * @generated from field: uint64 limit_amount = 4;
   */
  limitAmount: bigint;

  /**
   * required margin amount in decimal format
   *
   * @generated from field: uint64 required_margin = 7;
   */
  requiredMargin: bigint;

  /**
   * available amount in decimal format
   *
   * @generated from field: int64 available_amount = 8;
   */
  availableAmount: bigint;

  /**
   * margin call amount in decimal format
   *
   * @generated from field: uint64 margin_call_amount = 9;
   */
  marginCallAmount: bigint;

  /**
   * surplus amount in decimal format
   *
   * @generated from field: int64 surplus_amount = 10;
   */
  surplusAmount: bigint;

  /**
   * scheme type (Option1, Option2, etc.)
   *
   * @generated from field: devtool.v1.SchemeType scheme_type = 11;
   */
  schemeType: SchemeType;

  /**
   * PFE value (raw percentile, can be negative) in decimal format
   *
   * @generated from field: int64 pfe = 12;
   */
  pfe: bigint;

  /**
   * initial margin in decimal format
   *
   * @generated from field: uint64 initial_margin = 13;
   */
  initialMargin: bigint;

  /**
   * current collateral in decimal format (0 for Option2)
   *
   * @generated from field: uint64 current_collateral = 14;
   */
  currentCollateral: bigint;

  /**
   * floating PFE value (combined PFE - power-only PFE) in decimal format
   *
   * @generated from field: int64 floating_pfe = 15;
   */
  floatingPfe: bigint;

  /**
   * floating initial margin in decimal format
   *
   * @generated from field: uint64 floating_im = 16;
   */
  floatingIm: bigint;

  /**
   * MTM(day0), signed to support negative mark-to-market
   *
   * @generated from field: int64 mtm = 17;
   */
  mtm: bigint;
};

/**
 * Describes the message devtool.v1.CheckCreditRiskResultByTarget.
 * Use `create(CheckCreditRiskResultByTargetSchema)` to create a new message.
 */
export const CheckCreditRiskResultByTargetSchema: GenMessage<CheckCreditRiskResultByTarget> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 34);

/**
 * @generated from message devtool.v1.ExecuteRawSQLRequest
 */
export type ExecuteRawSQLRequest = Message<"devtool.v1.ExecuteRawSQLRequest"> & {
  /**
   * @generated from field: string sql = 1;
   */
  sql: string;
};

/**
 * Describes the message devtool.v1.ExecuteRawSQLRequest.
 * Use `create(ExecuteRawSQLRequestSchema)` to create a new message.
 */
export const ExecuteRawSQLRequestSchema: GenMessage<ExecuteRawSQLRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 35);

/**
 * @generated from message devtool.v1.ExecuteRawSQLResponse
 */
export type ExecuteRawSQLResponse = Message<"devtool.v1.ExecuteRawSQLResponse"> & {
};

/**
 * Describes the message devtool.v1.ExecuteRawSQLResponse.
 * Use `create(ExecuteRawSQLResponseSchema)` to create a new message.
 */
export const ExecuteRawSQLResponseSchema: GenMessage<ExecuteRawSQLResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 36);

/**
 * Deposit operation messages
 *
 * @generated from message devtool.v1.GetOrganizationDepositsRequest
 */
export type GetOrganizationDepositsRequest = Message<"devtool.v1.GetOrganizationDepositsRequest"> & {
  /**
   * Optional: specific org IDs, empty = all
   *
   * @generated from field: repeated string organization_ids = 1;
   */
  organizationIds: string[];
};

/**
 * Describes the message devtool.v1.GetOrganizationDepositsRequest.
 * Use `create(GetOrganizationDepositsRequestSchema)` to create a new message.
 */
export const GetOrganizationDepositsRequestSchema: GenMessage<GetOrganizationDepositsRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 37);

/**
 * @generated from message devtool.v1.GetOrganizationDepositsResponse
 */
export type GetOrganizationDepositsResponse = Message<"devtool.v1.GetOrganizationDepositsResponse"> & {
  /**
   * @generated from field: repeated devtool.v1.OrganizationDeposit deposits = 1;
   */
  deposits: OrganizationDeposit[];
};

/**
 * Describes the message devtool.v1.GetOrganizationDepositsResponse.
 * Use `create(GetOrganizationDepositsResponseSchema)` to create a new message.
 */
export const GetOrganizationDepositsResponseSchema: GenMessage<GetOrganizationDepositsResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 38);

/**
 * @generated from message devtool.v1.OrganizationDeposit
 */
export type OrganizationDeposit = Message<"devtool.v1.OrganizationDeposit"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: int64 current_amount = 2;
   */
  currentAmount: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp last_updated = 3;
   */
  lastUpdated?: Timestamp;
};

/**
 * Describes the message devtool.v1.OrganizationDeposit.
 * Use `create(OrganizationDepositSchema)` to create a new message.
 */
export const OrganizationDepositSchema: GenMessage<OrganizationDeposit> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 39);

/**
 * @generated from message devtool.v1.ModifyOrganizationDepositRequest
 */
export type ModifyOrganizationDepositRequest = Message<"devtool.v1.ModifyOrganizationDepositRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: int64 new_amount = 2;
   */
  newAmount: bigint;

  /**
   * Optional reason for the modification
   *
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * Describes the message devtool.v1.ModifyOrganizationDepositRequest.
 * Use `create(ModifyOrganizationDepositRequestSchema)` to create a new message.
 */
export const ModifyOrganizationDepositRequestSchema: GenMessage<ModifyOrganizationDepositRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 40);

/**
 * @generated from message devtool.v1.ModifyOrganizationDepositResponse
 */
export type ModifyOrganizationDepositResponse = Message<"devtool.v1.ModifyOrganizationDepositResponse"> & {
  /**
   * @generated from field: google.type.Decimal previous_amount = 1;
   */
  previousAmount?: Decimal;

  /**
   * @generated from field: int64 new_amount = 2;
   */
  newAmount: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp modified_at = 3;
   */
  modifiedAt?: Timestamp;
};

/**
 * Describes the message devtool.v1.ModifyOrganizationDepositResponse.
 * Use `create(ModifyOrganizationDepositResponseSchema)` to create a new message.
 */
export const ModifyOrganizationDepositResponseSchema: GenMessage<ModifyOrganizationDepositResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 41);

/**
 * @generated from message devtool.v1.ReconcileOrganizationDepositsRequest
 */
export type ReconcileOrganizationDepositsRequest = Message<"devtool.v1.ReconcileOrganizationDepositsRequest"> & {
  /**
   * Optional: specific org IDs, empty = all
   *
   * @generated from field: repeated string organization_ids = 1;
   */
  organizationIds: string[];

  /**
   * If true, automatically fix discrepancies
   *
   * @generated from field: bool apply_fixes = 2;
   */
  applyFixes: boolean;
};

/**
 * Describes the message devtool.v1.ReconcileOrganizationDepositsRequest.
 * Use `create(ReconcileOrganizationDepositsRequestSchema)` to create a new message.
 */
export const ReconcileOrganizationDepositsRequestSchema: GenMessage<ReconcileOrganizationDepositsRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 42);

/**
 * @generated from message devtool.v1.ReconcileOrganizationDepositsResponse
 */
export type ReconcileOrganizationDepositsResponse = Message<"devtool.v1.ReconcileOrganizationDepositsResponse"> & {
  /**
   * @generated from field: repeated devtool.v1.DepositReconciliation reconciliations = 1;
   */
  reconciliations: DepositReconciliation[];
};

/**
 * Describes the message devtool.v1.ReconcileOrganizationDepositsResponse.
 * Use `create(ReconcileOrganizationDepositsResponseSchema)` to create a new message.
 */
export const ReconcileOrganizationDepositsResponseSchema: GenMessage<ReconcileOrganizationDepositsResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 43);

/**
 * @generated from message devtool.v1.DepositReconciliation
 */
export type DepositReconciliation = Message<"devtool.v1.DepositReconciliation"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: google.type.Decimal current_deposit = 2;
   */
  currentDeposit?: Decimal;

  /**
   * @generated from field: google.type.Decimal calculated_deposit = 3;
   */
  calculatedDeposit?: Decimal;

  /**
   * current - calculated
   *
   * @generated from field: google.type.Decimal discrepancy = 4;
   */
  discrepancy?: Decimal;

  /**
   * @generated from field: bool has_discrepancy = 5;
   */
  hasDiscrepancy: boolean;

  /**
   * True if discrepancy was automatically corrected
   *
   * @generated from field: bool was_fixed = 6;
   */
  wasFixed: boolean;
};

/**
 * Describes the message devtool.v1.DepositReconciliation.
 * Use `create(DepositReconciliationSchema)` to create a new message.
 */
export const DepositReconciliationSchema: GenMessage<DepositReconciliation> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 44);

/**
 * Portfolio-based Liquidity PFE Calculation
 *
 * @generated from message devtool.v1.CalculateLiquidityPFEFromPortfoliosRequest
 */
export type CalculateLiquidityPFEFromPortfoliosRequest = Message<"devtool.v1.CalculateLiquidityPFEFromPortfoliosRequest"> & {
  /**
   * Base date for calculation (optional, defaults to current date)
   *
   * @generated from field: optional google.protobuf.Timestamp base_date = 1;
   */
  baseDate?: Timestamp;

  /**
   * Selected percentiles for calculation (optional, defaults to [0.99, 0.95, 0.9, 0.8, 0.5, 0.55])
   *
   * @generated from field: repeated double selected_percentiles = 2;
   */
  selectedPercentiles: number[];

  /**
   * Whether to include detailed results
   *
   * @generated from field: bool with_distribution_matrix = 3;
   */
  withDistributionMatrix: boolean;

  /**
   * @generated from field: bool with_selected_distributions = 4;
   */
  withSelectedDistributions: boolean;

  /**
   * @generated from field: bool with_snapshot = 5;
   */
  withSnapshot: boolean;

  /**
   * Portfolio IDs to calculate PFE for
   *
   * @generated from field: repeated string portfolio_ids = 6;
   */
  portfolioIds: string[];

  /**
   * Whether to include intermediate data
   *
   * Include VM settle data for each portfolio
   *
   * @generated from field: bool with_vm_settle = 7;
   */
  withVmSettle: boolean;

  /**
   * Include per-portfolio trade details
   *
   * @generated from field: bool with_portfolio_details = 8;
   */
  withPortfolioDetails: boolean;
};

/**
 * Describes the message devtool.v1.CalculateLiquidityPFEFromPortfoliosRequest.
 * Use `create(CalculateLiquidityPFEFromPortfoliosRequestSchema)` to create a new message.
 */
export const CalculateLiquidityPFEFromPortfoliosRequestSchema: GenMessage<CalculateLiquidityPFEFromPortfoliosRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 45);

/**
 * Response for portfolio-based calculation that returns the same format as CalculateLiquidityPFEResponse
 *
 * @generated from message devtool.v1.CalculateLiquidityPFEFromPortfoliosResponse
 */
export type CalculateLiquidityPFEFromPortfoliosResponse = Message<"devtool.v1.CalculateLiquidityPFEFromPortfoliosResponse"> & {
  /**
   * @generated from field: repeated devtool.v1.SimulatePFEOutputCSVsForPortfolio output_csvs = 1;
   */
  outputCsvs: SimulatePFEOutputCSVsForPortfolio[];
};

/**
 * Describes the message devtool.v1.CalculateLiquidityPFEFromPortfoliosResponse.
 * Use `create(CalculateLiquidityPFEFromPortfoliosResponseSchema)` to create a new message.
 */
export const CalculateLiquidityPFEFromPortfoliosResponseSchema: GenMessage<CalculateLiquidityPFEFromPortfoliosResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 46);

/**
 * Bank scheduled transaction messages
 *
 * @generated from message devtool.v1.GetBankScheduledTransactionsRequest
 */
export type GetBankScheduledTransactionsRequest = Message<"devtool.v1.GetBankScheduledTransactionsRequest"> & {
  /**
   * Optional: specific org IDs, empty = all
   *
   * @generated from field: repeated string organization_ids = 1;
   */
  organizationIds: string[];

  /**
   * Optional: filter by scheduled date from
   *
   * @generated from field: optional google.type.Date from_date = 2;
   */
  fromDate?: Date;

  /**
   * Optional: filter by scheduled date to
   *
   * @generated from field: optional google.type.Date to_date = 3;
   */
  toDate?: Date;

  /**
   * Optional: include settled transactions (default: false)
   *
   * @generated from field: optional bool include_settled = 4;
   */
  includeSettled?: boolean;
};

/**
 * Describes the message devtool.v1.GetBankScheduledTransactionsRequest.
 * Use `create(GetBankScheduledTransactionsRequestSchema)` to create a new message.
 */
export const GetBankScheduledTransactionsRequestSchema: GenMessage<GetBankScheduledTransactionsRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 47);

/**
 * @generated from message devtool.v1.GetBankScheduledTransactionsResponse
 */
export type GetBankScheduledTransactionsResponse = Message<"devtool.v1.GetBankScheduledTransactionsResponse"> & {
  /**
   * @generated from field: repeated devtool.v1.BankScheduledTransaction scheduled_transactions = 1;
   */
  scheduledTransactions: BankScheduledTransaction[];
};

/**
 * Describes the message devtool.v1.GetBankScheduledTransactionsResponse.
 * Use `create(GetBankScheduledTransactionsResponseSchema)` to create a new message.
 */
export const GetBankScheduledTransactionsResponseSchema: GenMessage<GetBankScheduledTransactionsResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 48);

/**
 * @generated from message devtool.v1.BankScheduledTransaction
 */
export type BankScheduledTransaction = Message<"devtool.v1.BankScheduledTransaction"> & {
  /**
   * @generated from field: string bank_scheduled_transaction_id = 1;
   */
  bankScheduledTransactionId: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: optional string deal_id = 3;
   */
  dealId?: string;

  /**
   * @generated from field: google.type.Date scheduled_date = 4;
   */
  scheduledDate?: Date;

  /**
   * @generated from field: int64 amount = 5;
   */
  amount: bigint;

  /**
   * @generated from field: int32 debit_credit_type = 7;
   */
  debitCreditType: number;

  /**
   * @generated from field: int32 usage = 8;
   */
  usage: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp settled_at = 10;
   */
  settledAt?: Timestamp;
};

/**
 * Describes the message devtool.v1.BankScheduledTransaction.
 * Use `create(BankScheduledTransactionSchema)` to create a new message.
 */
export const BankScheduledTransactionSchema: GenMessage<BankScheduledTransaction> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 49);

/**
 * Custom organization contract response that includes organization name
 *
 * @generated from message devtool.v1.DevToolOrganizationContract
 */
export type DevToolOrganizationContract = Message<"devtool.v1.DevToolOrganizationContract"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Added for compatibility with frontend
   *
   * @generated from field: string organization_name = 2;
   */
  organizationName: string;

  /**
   * @generated from field: internalapi.v1.PhysicalContractDeliveryType physical_contract_delivery_type = 3;
   */
  physicalContractDeliveryType: PhysicalContractDeliveryType;

  /**
   * @generated from field: repeated types.v1.DatePeriod payment_timings = 4;
   */
  paymentTimings: DatePeriod[];

  /**
   * @generated from field: internalapi.v1.EclearFeePattern eclear_fee_pattern = 5;
   */
  eclearFeePattern?: EclearFeePattern;

  /**
   * @generated from field: optional internalapi.v1.BankAccount payment_account = 6;
   */
  paymentAccount?: BankAccount;

  /**
   * @generated from field: internalapi.v1.ReceivingPaymentBankAccount receiving_payment_account = 7;
   */
  receivingPaymentAccount?: ReceivingPaymentBankAccount;

  /**
   * @generated from field: internalapi.v1.OrganizationOption organization_option = 8;
   */
  organizationOption?: OrganizationOption;

  /**
   * この組織に属するポートフォリオの与信枠（PhysicalLimit）の合計（JPY）。
   * Liquidity PFE Simulator のハイブリッドスキーム保証枠の prefill 用。
   *
   * @generated from field: uint64 physical_limit_total = 9;
   */
  physicalLimitTotal: bigint;

  /**
   * この組織の預託金残高（仮想口座の預託金、JPY）。Liquidity PFE Simulator の
   * 預託金（clearer_held_deposit）prefill 用。
   *
   * @generated from field: int64 deposit_total = 10;
   */
  depositTotal: bigint;
};

/**
 * Describes the message devtool.v1.DevToolOrganizationContract.
 * Use `create(DevToolOrganizationContractSchema)` to create a new message.
 */
export const DevToolOrganizationContractSchema: GenMessage<DevToolOrganizationContract> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 50);

/**
 * Custom response for ListOrganizationContracts that includes organization names
 *
 * @generated from message devtool.v1.DevToolServiceListOrganizationContractsResponse
 */
export type DevToolServiceListOrganizationContractsResponse = Message<"devtool.v1.DevToolServiceListOrganizationContractsResponse"> & {
  /**
   * @generated from field: repeated devtool.v1.DevToolOrganizationContract organization_contracts = 1;
   */
  organizationContracts: DevToolOrganizationContract[];
};

/**
 * Describes the message devtool.v1.DevToolServiceListOrganizationContractsResponse.
 * Use `create(DevToolServiceListOrganizationContractsResponseSchema)` to create a new message.
 */
export const DevToolServiceListOrganizationContractsResponseSchema: GenMessage<DevToolServiceListOrganizationContractsResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 51);

/**
 * Organization member messages (for posting-simulator)
 *
 * @generated from message devtool.v1.ListMembersRequest
 */
export type ListMembersRequest = Message<"devtool.v1.ListMembersRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message devtool.v1.ListMembersRequest.
 * Use `create(ListMembersRequestSchema)` to create a new message.
 */
export const ListMembersRequestSchema: GenMessage<ListMembersRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 52);

/**
 * @generated from message devtool.v1.ListMembersResponse
 */
export type ListMembersResponse = Message<"devtool.v1.ListMembersResponse"> & {
  /**
   * @generated from field: repeated devtool.v1.Member members = 1;
   */
  members: Member[];
};

/**
 * Describes the message devtool.v1.ListMembersResponse.
 * Use `create(ListMembersResponseSchema)` to create a new message.
 */
export const ListMembersResponseSchema: GenMessage<ListMembersResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 53);

/**
 * @generated from message devtool.v1.Member
 */
export type Member = Message<"devtool.v1.Member"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string phone_number = 3;
   */
  phoneNumber: string;

  /**
   * @generated from field: string email = 4;
   */
  email: string;
};

/**
 * Describes the message devtool.v1.Member.
 * Use `create(MemberSchema)` to create a new message.
 */
export const MemberSchema: GenMessage<Member> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 54);

/**
 * EEX messages (for posting-simulator)
 *
 * @generated from message devtool.v1.ListClearingAccountsRequest
 */
export type ListClearingAccountsRequest = Message<"devtool.v1.ListClearingAccountsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message devtool.v1.ListClearingAccountsRequest.
 * Use `create(ListClearingAccountsRequestSchema)` to create a new message.
 */
export const ListClearingAccountsRequestSchema: GenMessage<ListClearingAccountsRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 55);

/**
 * @generated from message devtool.v1.ListClearingAccountsResponse
 */
export type ListClearingAccountsResponse = Message<"devtool.v1.ListClearingAccountsResponse"> & {
  /**
   * @generated from field: repeated devtool.v1.ClearingAccount clearing_accounts = 1;
   */
  clearingAccounts: ClearingAccount[];
};

/**
 * Describes the message devtool.v1.ListClearingAccountsResponse.
 * Use `create(ListClearingAccountsResponseSchema)` to create a new message.
 */
export const ListClearingAccountsResponseSchema: GenMessage<ListClearingAccountsResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 56);

/**
 * @generated from message devtool.v1.ClearingAccount
 */
export type ClearingAccount = Message<"devtool.v1.ClearingAccount"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message devtool.v1.ClearingAccount.
 * Use `create(ClearingAccountSchema)` to create a new message.
 */
export const ClearingAccountSchema: GenMessage<ClearingAccount> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 57);

/**
 * @generated from message devtool.v1.ListTradersRequest
 */
export type ListTradersRequest = Message<"devtool.v1.ListTradersRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message devtool.v1.ListTradersRequest.
 * Use `create(ListTradersRequestSchema)` to create a new message.
 */
export const ListTradersRequestSchema: GenMessage<ListTradersRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 58);

/**
 * @generated from message devtool.v1.ListTradersResponse
 */
export type ListTradersResponse = Message<"devtool.v1.ListTradersResponse"> & {
  /**
   * @generated from field: repeated devtool.v1.Trader traders = 1;
   */
  traders: Trader[];
};

/**
 * Describes the message devtool.v1.ListTradersResponse.
 * Use `create(ListTradersResponseSchema)` to create a new message.
 */
export const ListTradersResponseSchema: GenMessage<ListTradersResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 59);

/**
 * @generated from message devtool.v1.Trader
 */
export type Trader = Message<"devtool.v1.Trader"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message devtool.v1.Trader.
 * Use `create(TraderSchema)` to create a new message.
 */
export const TraderSchema: GenMessage<Trader> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 60);

/**
 * @generated from message devtool.v1.DebugFeatureFlagRequest
 */
export type DebugFeatureFlagRequest = Message<"devtool.v1.DebugFeatureFlagRequest"> & {
};

/**
 * Describes the message devtool.v1.DebugFeatureFlagRequest.
 * Use `create(DebugFeatureFlagRequestSchema)` to create a new message.
 */
export const DebugFeatureFlagRequestSchema: GenMessage<DebugFeatureFlagRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 61);

/**
 * @generated from message devtool.v1.DebugFeatureFlagResponse
 */
export type DebugFeatureFlagResponse = Message<"devtool.v1.DebugFeatureFlagResponse"> & {
  /**
   * @generated from field: string msg = 1;
   */
  msg: string;
};

/**
 * Describes the message devtool.v1.DebugFeatureFlagResponse.
 * Use `create(DebugFeatureFlagResponseSchema)` to create a new message.
 */
export const DebugFeatureFlagResponseSchema: GenMessage<DebugFeatureFlagResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 62);

/**
 * Time operations messages
 *
 * @generated from message devtool.v1.GetCurrentTimeRequest
 */
export type GetCurrentTimeRequest = Message<"devtool.v1.GetCurrentTimeRequest"> & {
};

/**
 * Describes the message devtool.v1.GetCurrentTimeRequest.
 * Use `create(GetCurrentTimeRequestSchema)` to create a new message.
 */
export const GetCurrentTimeRequestSchema: GenMessage<GetCurrentTimeRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 63);

/**
 * @generated from message devtool.v1.GetCurrentTimeResponse
 */
export type GetCurrentTimeResponse = Message<"devtool.v1.GetCurrentTimeResponse"> & {
  /**
   * RFC3339 formatted current time
   *
   * @generated from field: string now = 1;
   */
  now: string;

  /**
   * "ctx" | "env" | "system"
   *
   * @generated from field: string source = 2;
   */
  source: string;

  /**
   * Applied offset in hours
   *
   * @generated from field: int32 offset_hours = 3;
   */
  offsetHours: number;
};

/**
 * Describes the message devtool.v1.GetCurrentTimeResponse.
 * Use `create(GetCurrentTimeResponseSchema)` to create a new message.
 */
export const GetCurrentTimeResponseSchema: GenMessage<GetCurrentTimeResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 64);

/**
 * Deal archiving messages
 *
 * @generated from message devtool.v1.ArchiveDealRequest
 */
export type ArchiveDealRequest = Message<"devtool.v1.ArchiveDealRequest"> & {
  /**
   * @generated from field: string platform_deal_id = 1;
   */
  platformDealId: string;
};

/**
 * Describes the message devtool.v1.ArchiveDealRequest.
 * Use `create(ArchiveDealRequestSchema)` to create a new message.
 */
export const ArchiveDealRequestSchema: GenMessage<ArchiveDealRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 65);

/**
 * @generated from message devtool.v1.ArchiveDealResponse
 */
export type ArchiveDealResponse = Message<"devtool.v1.ArchiveDealResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp archived_at = 2;
   */
  archivedAt?: Timestamp;
};

/**
 * Describes the message devtool.v1.ArchiveDealResponse.
 * Use `create(ArchiveDealResponseSchema)` to create a new message.
 */
export const ArchiveDealResponseSchema: GenMessage<ArchiveDealResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 66);

/**
 * Deal change operation messages
 *
 * @generated from message devtool.v1.ChangeDealRequest
 */
export type ChangeDealRequest = Message<"devtool.v1.ChangeDealRequest"> & {
  /**
   * @generated from field: repeated devtool.v1.ChangeDealUpdateOperation updates = 1;
   */
  updates: ChangeDealUpdateOperation[];

  /**
   * @generated from field: repeated devtool.v1.ChangeDealDeleteOperation deletes = 2;
   */
  deletes: ChangeDealDeleteOperation[];

  /**
   * @generated from field: repeated devtool.v1.ChangeDealCreateOperation creates = 3;
   */
  creates: ChangeDealCreateOperation[];
};

/**
 * Describes the message devtool.v1.ChangeDealRequest.
 * Use `create(ChangeDealRequestSchema)` to create a new message.
 */
export const ChangeDealRequestSchema: GenMessage<ChangeDealRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 67);

/**
 * @generated from message devtool.v1.ChangeDealUpdateOperation
 */
export type ChangeDealUpdateOperation = Message<"devtool.v1.ChangeDealUpdateOperation"> & {
  /**
   * @generated from field: string platform_deal_id = 1;
   */
  platformDealId: string;

  /**
   * @generated from field: types.v1.DeliveryPeriodType delivery_period_type = 2;
   */
  deliveryPeriodType: DeliveryPeriodType;

  /**
   * @generated from field: google.protobuf.Timestamp delivery_start_at = 3;
   */
  deliveryStartAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp delivery_end_at = 4;
   */
  deliveryEndAt?: Timestamp;

  /**
   * @generated from field: optional types.v1.DeliveryType delivery_type = 5;
   */
  deliveryType?: DeliveryType;

  /**
   * organization_id to filter which transaction's delivery_type to update.
   *
   * @generated from field: string organization_id = 6;
   */
  organizationId: string;

  /**
   * settlement_difference_target_area_code (差額精算対象エリア) to set on the transaction
   * when delivery_type becomes JEPX. Only allowed together with delivery_type = JEPX;
   * a change away from JEPX clears any existing value.
   * Omitting the field keeps the value the transaction already has. To remove an existing
   * value, send AREA_CODE_UNSPECIFIED explicitly instead of omitting the field.
   *
   * @generated from field: optional types.v1.AreaCode settlement_difference_target_area_code = 7;
   */
  settlementDifferenceTargetAreaCode?: AreaCode;
};

/**
 * Describes the message devtool.v1.ChangeDealUpdateOperation.
 * Use `create(ChangeDealUpdateOperationSchema)` to create a new message.
 */
export const ChangeDealUpdateOperationSchema: GenMessage<ChangeDealUpdateOperation> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 68);

/**
 * @generated from message devtool.v1.ChangeDealDeleteOperation
 */
export type ChangeDealDeleteOperation = Message<"devtool.v1.ChangeDealDeleteOperation"> & {
  /**
   * @generated from field: string platform_deal_id = 1;
   */
  platformDealId: string;
};

/**
 * Describes the message devtool.v1.ChangeDealDeleteOperation.
 * Use `create(ChangeDealDeleteOperationSchema)` to create a new message.
 */
export const ChangeDealDeleteOperationSchema: GenMessage<ChangeDealDeleteOperation> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 69);

/**
 * @generated from message devtool.v1.ChangeDealCreateOperation
 */
export type ChangeDealCreateOperation = Message<"devtool.v1.ChangeDealCreateOperation"> & {
  /**
   * @generated from field: string source_platform_deal_id = 1;
   */
  sourcePlatformDealId: string;

  /**
   * @generated from field: optional types.v1.DeliveryType delivery_type = 2;
   */
  deliveryType?: DeliveryType;

  /**
   * @generated from field: repeated devtool.v1.ChangeDealCreateLeg legs = 3;
   */
  legs: ChangeDealCreateLeg[];

  /**
   * organization_id to filter which transaction's delivery_type to update.
   * Required when delivery_type is specified.
   *
   * @generated from field: optional string organization_id = 4;
   */
  organizationId?: string;
};

/**
 * Describes the message devtool.v1.ChangeDealCreateOperation.
 * Use `create(ChangeDealCreateOperationSchema)` to create a new message.
 */
export const ChangeDealCreateOperationSchema: GenMessage<ChangeDealCreateOperation> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 70);

/**
 * @generated from message devtool.v1.ChangeDealCreateLeg
 */
export type ChangeDealCreateLeg = Message<"devtool.v1.ChangeDealCreateLeg"> & {
  /**
   * @generated from field: types.v1.DeliveryPeriodType delivery_period_type = 1;
   */
  deliveryPeriodType: DeliveryPeriodType;

  /**
   * @generated from field: google.protobuf.Timestamp delivery_start_at = 2;
   */
  deliveryStartAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp delivery_end_at = 3;
   */
  deliveryEndAt?: Timestamp;
};

/**
 * Describes the message devtool.v1.ChangeDealCreateLeg.
 * Use `create(ChangeDealCreateLegSchema)` to create a new message.
 */
export const ChangeDealCreateLegSchema: GenMessage<ChangeDealCreateLeg> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 71);

/**
 * @generated from message devtool.v1.ChangeDealResponse
 */
export type ChangeDealResponse = Message<"devtool.v1.ChangeDealResponse"> & {
  /**
   * @generated from field: repeated devtool.v1.ChangeDealResult results = 1;
   */
  results: ChangeDealResult[];
};

/**
 * Describes the message devtool.v1.ChangeDealResponse.
 * Use `create(ChangeDealResponseSchema)` to create a new message.
 */
export const ChangeDealResponseSchema: GenMessage<ChangeDealResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 72);

/**
 * @generated from message devtool.v1.ChangeDealResult
 */
export type ChangeDealResult = Message<"devtool.v1.ChangeDealResult"> & {
  /**
   * @generated from field: string platform_deal_id = 1;
   */
  platformDealId: string;

  /**
   * @generated from field: string operation = 2;
   */
  operation: string;

  /**
   * @generated from field: string platform_deal_code = 3;
   */
  platformDealCode: string;

  /**
   * @generated from field: string eclear_deal_code = 4;
   */
  eclearDealCode: string;
};

/**
 * Describes the message devtool.v1.ChangeDealResult.
 * Use `create(ChangeDealResultSchema)` to create a new message.
 */
export const ChangeDealResultSchema: GenMessage<ChangeDealResult> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 73);

/**
 * DevTool user setting messages
 *
 * @generated from message devtool.v1.GetDevToolUserSettingRequest
 */
export type GetDevToolUserSettingRequest = Message<"devtool.v1.GetDevToolUserSettingRequest"> & {
  /**
   * User ID from Auth0
   *
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * Describes the message devtool.v1.GetDevToolUserSettingRequest.
 * Use `create(GetDevToolUserSettingRequestSchema)` to create a new message.
 */
export const GetDevToolUserSettingRequestSchema: GenMessage<GetDevToolUserSettingRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 74);

/**
 * @generated from message devtool.v1.GetDevToolUserSettingResponse
 */
export type GetDevToolUserSettingResponse = Message<"devtool.v1.GetDevToolUserSettingResponse"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * JSON string containing devtool user setting
   *
   * @generated from field: string setting_json = 2;
   */
  settingJson: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 3;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 4;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message devtool.v1.GetDevToolUserSettingResponse.
 * Use `create(GetDevToolUserSettingResponseSchema)` to create a new message.
 */
export const GetDevToolUserSettingResponseSchema: GenMessage<GetDevToolUserSettingResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 75);

/**
 * @generated from message devtool.v1.UpdateDevToolUserSettingRequest
 */
export type UpdateDevToolUserSettingRequest = Message<"devtool.v1.UpdateDevToolUserSettingRequest"> & {
  /**
   * User ID from Auth0
   *
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * JSON string containing devtool user setting
   *
   * @generated from field: string setting_json = 2;
   */
  settingJson: string;
};

/**
 * Describes the message devtool.v1.UpdateDevToolUserSettingRequest.
 * Use `create(UpdateDevToolUserSettingRequestSchema)` to create a new message.
 */
export const UpdateDevToolUserSettingRequestSchema: GenMessage<UpdateDevToolUserSettingRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 76);

/**
 * @generated from message devtool.v1.UpdateDevToolUserSettingResponse
 */
export type UpdateDevToolUserSettingResponse = Message<"devtool.v1.UpdateDevToolUserSettingResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 2;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message devtool.v1.UpdateDevToolUserSettingResponse.
 * Use `create(UpdateDevToolUserSettingResponseSchema)` to create a new message.
 */
export const UpdateDevToolUserSettingResponseSchema: GenMessage<UpdateDevToolUserSettingResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 77);

/**
 * @generated from message devtool.v1.StartBulkSimulationRequest
 */
export type StartBulkSimulationRequest = Message<"devtool.v1.StartBulkSimulationRequest"> & {
  /**
   * CSV file containing orders data
   *
   * @generated from field: types.v1.CSVFileData orders_csv = 1;
   */
  ordersCsv?: CSVFileData;

  /**
   * default = current time
   *
   * @generated from field: optional google.protobuf.Timestamp simulation_target_now = 2;
   */
  simulationTargetNow?: Timestamp;

  /**
   * default = false
   *
   * @generated from field: optional bool ignore_existing_deals = 3;
   */
  ignoreExistingDeals?: boolean;

  /**
   * Optional custom selected indices for PFE calculation
   *
   * @generated from field: repeated double selected_indices = 4;
   */
  selectedIndices: number[];

  /**
   * default = false
   *
   * @generated from field: optional bool skip_occto_master_check = 5;
   */
  skipOcctoMasterCheck?: boolean;

  /**
   * default = false
   *
   * @generated from field: optional bool skip_fee_calculation = 6;
   */
  skipFeeCalculation?: boolean;
};

/**
 * Describes the message devtool.v1.StartBulkSimulationRequest.
 * Use `create(StartBulkSimulationRequestSchema)` to create a new message.
 */
export const StartBulkSimulationRequestSchema: GenMessage<StartBulkSimulationRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 78);

/**
 * @generated from message devtool.v1.StartBulkSimulationResponse
 */
export type StartBulkSimulationResponse = Message<"devtool.v1.StartBulkSimulationResponse"> & {
  /**
   * UUID of the created job
   *
   * @generated from field: string job_id = 1;
   */
  jobId: string;

  /**
   * Total number of simulation groups
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message devtool.v1.StartBulkSimulationResponse.
 * Use `create(StartBulkSimulationResponseSchema)` to create a new message.
 */
export const StartBulkSimulationResponseSchema: GenMessage<StartBulkSimulationResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 79);

/**
 * @generated from message devtool.v1.GetBulkSimulationStatusRequest
 */
export type GetBulkSimulationStatusRequest = Message<"devtool.v1.GetBulkSimulationStatusRequest"> & {
  /**
   * @generated from field: string job_id = 1;
   */
  jobId: string;
};

/**
 * Describes the message devtool.v1.GetBulkSimulationStatusRequest.
 * Use `create(GetBulkSimulationStatusRequestSchema)` to create a new message.
 */
export const GetBulkSimulationStatusRequestSchema: GenMessage<GetBulkSimulationStatusRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 80);

/**
 * @generated from message devtool.v1.GetBulkSimulationStatusResponse
 */
export type GetBulkSimulationStatusResponse = Message<"devtool.v1.GetBulkSimulationStatusResponse"> & {
  /**
   * @generated from field: string job_id = 1;
   */
  jobId: string;

  /**
   * @generated from field: devtool.v1.BulkSimulationJobStatus status = 2;
   */
  status: BulkSimulationJobStatus;

  /**
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;

  /**
   * @generated from field: int32 processed_count = 4;
   */
  processedCount: number;

  /**
   * Error message if status is FAILED
   *
   * @generated from field: string error_message = 5;
   */
  errorMessage: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message devtool.v1.GetBulkSimulationStatusResponse.
 * Use `create(GetBulkSimulationStatusResponseSchema)` to create a new message.
 */
export const GetBulkSimulationStatusResponseSchema: GenMessage<GetBulkSimulationStatusResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 81);

/**
 * @generated from message devtool.v1.GetBulkSimulationResultRequest
 */
export type GetBulkSimulationResultRequest = Message<"devtool.v1.GetBulkSimulationResultRequest"> & {
  /**
   * @generated from field: string job_id = 1;
   */
  jobId: string;
};

/**
 * Describes the message devtool.v1.GetBulkSimulationResultRequest.
 * Use `create(GetBulkSimulationResultRequestSchema)` to create a new message.
 */
export const GetBulkSimulationResultRequestSchema: GenMessage<GetBulkSimulationResultRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 82);

/**
 * @generated from message devtool.v1.GetBulkSimulationResultResponse
 */
export type GetBulkSimulationResultResponse = Message<"devtool.v1.GetBulkSimulationResultResponse"> & {
  /**
   * Complete CSV result data
   *
   * @generated from field: bytes csv_data = 1;
   */
  csvData: Uint8Array;

  /**
   * Suggested file name for download
   *
   * @generated from field: string file_name = 2;
   */
  fileName: string;
};

/**
 * Describes the message devtool.v1.GetBulkSimulationResultResponse.
 * Use `create(GetBulkSimulationResultResponseSchema)` to create a new message.
 */
export const GetBulkSimulationResultResponseSchema: GenMessage<GetBulkSimulationResultResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 83);

/**
 * Portfolio MTM retrieval messages
 *
 * @generated from message devtool.v1.GetPortfolioMTMRequest
 */
export type GetPortfolioMTMRequest = Message<"devtool.v1.GetPortfolioMTMRequest"> & {
  /**
   * 日付のみ, future not allowed
   *
   * @generated from field: google.type.Date reference_date = 1;
   */
  referenceDate?: Date;

  /**
   * required
   *
   * @generated from field: string portfolio_id = 2;
   */
  portfolioId: string;

  /**
   * default: MTM_USAGE_TYPE_PER_ORGANIZATION
   *
   * @generated from field: optional types.v1.MTMUsageType mtm_usage_type = 3;
   */
  mtmUsageType?: MTMUsageType;

  /**
   * default: MTM_PERSPECTIVE_ECLEAR
   *
   * @generated from field: optional types.v1.MTMPerspective mtm_perspective = 4;
   */
  mtmPerspective?: MTMPerspective;

  /**
   * default: false
   *
   * @generated from field: bool is_eod = 5;
   */
  isEod: boolean;

  /**
   * default: false - trueの場合、基準日より前の月をMTM計算から除外
   *
   * @generated from field: bool exclude_past_months = 6;
   */
  excludePastMonths: boolean;
};

/**
 * Describes the message devtool.v1.GetPortfolioMTMRequest.
 * Use `create(GetPortfolioMTMRequestSchema)` to create a new message.
 */
export const GetPortfolioMTMRequestSchema: GenMessage<GetPortfolioMTMRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 84);

/**
 * @generated from message devtool.v1.GetPortfolioMTMResponse
 */
export type GetPortfolioMTMResponse = Message<"devtool.v1.GetPortfolioMTMResponse"> & {
  /**
   * @generated from field: devtool.v1.PortfolioTotal portfolio_total = 1;
   */
  portfolioTotal?: PortfolioTotal;

  /**
   * @generated from field: repeated devtool.v1.MTMByOrganization per_org = 2;
   */
  perOrg: MTMByOrganization[];

  /**
   * @generated from field: repeated devtool.v1.MTMByDeal per_deal = 3;
   */
  perDeal: MTMByDeal[];

  /**
   * @generated from field: repeated devtool.v1.MonthlyMTM monthly = 4;
   */
  monthly: MonthlyMTM[];

  /**
   * @generated from field: repeated devtool.v1.DailyMTM daily = 5;
   */
  daily: DailyMTM[];
};

/**
 * Describes the message devtool.v1.GetPortfolioMTMResponse.
 * Use `create(GetPortfolioMTMResponseSchema)` to create a new message.
 */
export const GetPortfolioMTMResponseSchema: GenMessage<GetPortfolioMTMResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 85);

/**
 * @generated from message devtool.v1.PortfolioTotal
 */
export type PortfolioTotal = Message<"devtool.v1.PortfolioTotal"> & {
  /**
   * @generated from field: string portfolio_id = 1;
   */
  portfolioId: string;

  /**
   * @generated from field: google.type.Decimal mtm_total = 2;
   */
  mtmTotal?: Decimal;

  /**
   * @generated from field: google.type.Date reference_date = 3;
   */
  referenceDate?: Date;
};

/**
 * Describes the message devtool.v1.PortfolioTotal.
 * Use `create(PortfolioTotalSchema)` to create a new message.
 */
export const PortfolioTotalSchema: GenMessage<PortfolioTotal> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 86);

/**
 * @generated from message devtool.v1.MTMByOrganization
 */
export type MTMByOrganization = Message<"devtool.v1.MTMByOrganization"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: google.type.Decimal mtm_total = 2;
   */
  mtmTotal?: Decimal;
};

/**
 * Describes the message devtool.v1.MTMByOrganization.
 * Use `create(MTMByOrganizationSchema)` to create a new message.
 */
export const MTMByOrganizationSchema: GenMessage<MTMByOrganization> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 87);

/**
 * @generated from message devtool.v1.MTMByDeal
 */
export type MTMByDeal = Message<"devtool.v1.MTMByDeal"> & {
  /**
   * @generated from field: string platform_deal_id = 1;
   */
  platformDealId: string;

  /**
   * @generated from field: string transaction_id = 2;
   */
  transactionId: string;

  /**
   * @generated from field: google.type.Decimal mtm_total = 3;
   */
  mtmTotal?: Decimal;

  /**
   * BUY or SELL
   *
   * @generated from field: string position = 4;
   */
  position: string;

  /**
   * 数量(kWh)
   *
   * @generated from field: google.type.Decimal volume_kwh = 5;
   */
  volumeKwh?: Decimal;

  /**
   * 約定価格(円/kWh)
   *
   * @generated from field: google.type.Decimal unit_price_per_kwh = 6;
   */
  unitPricePerKwh?: Decimal;

  /**
   * 受給開始日
   *
   * @generated from field: google.type.Date delivery_start_date = 7;
   */
  deliveryStartDate?: Date;

  /**
   * 受給終了日(exclusive)
   *
   * @generated from field: google.type.Date delivery_end_date = 8;
   */
  deliveryEndDate?: Date;

  /**
   * エリア
   *
   * @generated from field: types.v1.AreaCode area_code = 9;
   */
  areaCode: AreaCode;

  /**
   * 時間帯区分
   *
   * @generated from field: types.v1.DeliveryHourType delivery_hour_type = 10;
   */
  deliveryHourType: DeliveryHourType;

  /**
   * 受給期間区分
   *
   * @generated from field: types.v1.DeliveryPeriodType delivery_period_type = 11;
   */
  deliveryPeriodType: DeliveryPeriodType;

  /**
   * 受渡区分
   *
   * @generated from field: types.v1.DeliveryType delivery_type = 12;
   */
  deliveryType: DeliveryType;

  /**
   * 相手先受渡区分
   *
   * @generated from field: types.v1.DeliveryType counterparty_delivery_type = 13;
   */
  counterpartyDeliveryType: DeliveryType;
};

/**
 * Describes the message devtool.v1.MTMByDeal.
 * Use `create(MTMByDealSchema)` to create a new message.
 */
export const MTMByDealSchema: GenMessage<MTMByDeal> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 88);

/**
 * @generated from message devtool.v1.MonthlyMTM
 */
export type MonthlyMTM = Message<"devtool.v1.MonthlyMTM"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: uint32 year = 2;
   */
  year: number;

  /**
   * @generated from field: uint32 month = 3;
   */
  month: number;

  /**
   * transaction×年月で一意
   *
   * @generated from field: string transaction_id = 4;
   */
  transactionId: string;

  /**
   * @generated from field: google.type.Decimal price_difference = 5;
   */
  priceDifference?: Decimal;

  /**
   * @generated from field: google.type.Decimal goods = 6;
   */
  goods?: Decimal;

  /**
   * 契約価格(円/kWh)
   *
   * @generated from field: google.type.Decimal unit_price_per_kwh = 7;
   */
  unitPricePerKwh?: Decimal;

  /**
   * 数量(kWh)
   *
   * @generated from field: google.type.Decimal volume_kwh = 8;
   */
  volumeKwh?: Decimal;

  /**
   * curve snapshot for row
   *
   * @generated from field: optional google.type.Decimal enechain_curve = 9;
   */
  enechainCurve?: Decimal;

  /**
   * @generated from field: optional google.type.Decimal eex_settlement = 10;
   */
  eexSettlement?: Decimal;

  /**
   * 確定品代
   *
   * @generated from field: optional google.type.Decimal final_payment_amount = 11;
   */
  finalPaymentAmount?: Decimal;
};

/**
 * Describes the message devtool.v1.MonthlyMTM.
 * Use `create(MonthlyMTMSchema)` to create a new message.
 */
export const MonthlyMTMSchema: GenMessage<MonthlyMTM> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 89);

/**
 * @generated from message devtool.v1.DailyMTM
 */
export type DailyMTM = Message<"devtool.v1.DailyMTM"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string transaction_id = 2;
   */
  transactionId: string;

  /**
   * @generated from field: google.type.Date date = 3;
   */
  date?: Date;

  /**
   * @generated from field: google.type.Decimal price_difference = 4;
   */
  priceDifference?: Decimal;

  /**
   * JEPXは時間帯別配列をJSON相当で返却（表示はUI側で最適化）
   *
   * @generated from field: repeated devtool.v1.JEPXSettlement jepx_settlements = 5;
   */
  jepxSettlements: JEPXSettlement[];

  /**
   * @generated from field: optional google.type.Decimal enechain_curve = 6;
   */
  enechainCurve?: Decimal;

  /**
   * @generated from field: optional google.type.Decimal eex_settlement = 7;
   */
  eexSettlement?: Decimal;

  /**
   * 契約価格(円/kWh)
   *
   * @generated from field: google.type.Decimal unit_price_per_kwh = 8;
   */
  unitPricePerKwh?: Decimal;

  /**
   * 数量(kWh)
   *
   * @generated from field: google.type.Decimal volume_kwh = 9;
   */
  volumeKwh?: Decimal;

  /**
   * 品代
   *
   * @generated from field: google.type.Decimal goods = 10;
   */
  goods?: Decimal;

  /**
   * 確定品代
   *
   * @generated from field: optional google.type.Decimal final_payment_amount = 11;
   */
  finalPaymentAmount?: Decimal;
};

/**
 * Describes the message devtool.v1.DailyMTM.
 * Use `create(DailyMTMSchema)` to create a new message.
 */
export const DailyMTMSchema: GenMessage<DailyMTM> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 90);

/**
 * @generated from message devtool.v1.JEPXSettlement
 */
export type JEPXSettlement = Message<"devtool.v1.JEPXSettlement"> & {
  /**
   * 1-48 (30-minute slots)
   *
   * @generated from field: uint32 slot_index = 1;
   */
  slotIndex: number;

  /**
   * @generated from field: google.type.Decimal price = 2;
   */
  price?: Decimal;
};

/**
 * Describes the message devtool.v1.JEPXSettlement.
 * Use `create(JEPXSettlementSchema)` to create a new message.
 */
export const JEPXSettlementSchema: GenMessage<JEPXSettlement> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 91);

/**
 * ListTotalCreditAmounts - List saved total credit amounts
 *
 * @generated from message devtool.v1.ListTotalCreditAmountsRequest
 */
export type ListTotalCreditAmountsRequest = Message<"devtool.v1.ListTotalCreditAmountsRequest"> & {
  /**
   * Optional: defaults to today if not specified
   *
   * @generated from field: google.type.Date ref_date = 1;
   */
  refDate?: Date;

  /**
   * Optional: specific portfolio IDs, empty = all
   *
   * @generated from field: repeated string portfolio_ids = 2;
   */
  portfolioIds: string[];
};

/**
 * Describes the message devtool.v1.ListTotalCreditAmountsRequest.
 * Use `create(ListTotalCreditAmountsRequestSchema)` to create a new message.
 */
export const ListTotalCreditAmountsRequestSchema: GenMessage<ListTotalCreditAmountsRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 92);

/**
 * @generated from message devtool.v1.ListTotalCreditAmountsResponse
 */
export type ListTotalCreditAmountsResponse = Message<"devtool.v1.ListTotalCreditAmountsResponse"> & {
  /**
   * @generated from field: repeated devtool.v1.TotalCreditAmountItem items = 1;
   */
  items: TotalCreditAmountItem[];
};

/**
 * Describes the message devtool.v1.ListTotalCreditAmountsResponse.
 * Use `create(ListTotalCreditAmountsResponseSchema)` to create a new message.
 */
export const ListTotalCreditAmountsResponseSchema: GenMessage<ListTotalCreditAmountsResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 93);

/**
 * @generated from message devtool.v1.TotalCreditAmountItem
 */
export type TotalCreditAmountItem = Message<"devtool.v1.TotalCreditAmountItem"> & {
  /**
   * @generated from field: string portfolio_id = 1;
   */
  portfolioId: string;

  /**
   * @generated from field: string portfolio_name = 2;
   */
  portfolioName: string;

  /**
   * @generated from field: devtool.v1.CalculationTargetType risk_calculation_target = 3;
   */
  riskCalculationTarget: CalculationTargetType;

  /**
   * @generated from field: int64 total_amount = 4;
   */
  totalAmount: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: repeated devtool.v1.TotalCreditAmountDetailItem details = 6;
   */
  details: TotalCreditAmountDetailItem[];
};

/**
 * Describes the message devtool.v1.TotalCreditAmountItem.
 * Use `create(TotalCreditAmountItemSchema)` to create a new message.
 */
export const TotalCreditAmountItemSchema: GenMessage<TotalCreditAmountItem> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 94);

/**
 * @generated from message devtool.v1.TotalCreditAmountDetailItem
 */
export type TotalCreditAmountDetailItem = Message<"devtool.v1.TotalCreditAmountDetailItem"> & {
  /**
   * "initial_deposit", "variation_margin", "threshold"
   *
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: int64 amount = 2;
   */
  amount: bigint;
};

/**
 * Describes the message devtool.v1.TotalCreditAmountDetailItem.
 * Use `create(TotalCreditAmountDetailItemSchema)` to create a new message.
 */
export const TotalCreditAmountDetailItemSchema: GenMessage<TotalCreditAmountDetailItem> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 95);

/**
 * CalculateTotalCreditAmount - Calculate total credit amount for portfolios
 *
 * @generated from message devtool.v1.CalculateTotalCreditAmountRequest
 */
export type CalculateTotalCreditAmountRequest = Message<"devtool.v1.CalculateTotalCreditAmountRequest"> & {
  /**
   * Optional: defaults to today if not specified
   *
   * @generated from field: google.type.Date ref_date = 1;
   */
  refDate?: Date;

  /**
   * Optional: specific portfolio IDs, empty = all
   *
   * @generated from field: repeated string portfolio_ids = 2;
   */
  portfolioIds: string[];
};

/**
 * Describes the message devtool.v1.CalculateTotalCreditAmountRequest.
 * Use `create(CalculateTotalCreditAmountRequestSchema)` to create a new message.
 */
export const CalculateTotalCreditAmountRequestSchema: GenMessage<CalculateTotalCreditAmountRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 96);

/**
 * @generated from message devtool.v1.CalculateTotalCreditAmountResponse
 */
export type CalculateTotalCreditAmountResponse = Message<"devtool.v1.CalculateTotalCreditAmountResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: int32 portfolios_processed = 2;
   */
  portfoliosProcessed: number;

  /**
   * @generated from field: repeated devtool.v1.TotalCreditAmountResult results = 3;
   */
  results: TotalCreditAmountResult[];
};

/**
 * Describes the message devtool.v1.CalculateTotalCreditAmountResponse.
 * Use `create(CalculateTotalCreditAmountResponseSchema)` to create a new message.
 */
export const CalculateTotalCreditAmountResponseSchema: GenMessage<CalculateTotalCreditAmountResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 97);

/**
 * @generated from message devtool.v1.TotalCreditAmountResult
 */
export type TotalCreditAmountResult = Message<"devtool.v1.TotalCreditAmountResult"> & {
  /**
   * @generated from field: string portfolio_id = 1;
   */
  portfolioId: string;

  /**
   * @generated from field: string portfolio_name = 2;
   */
  portfolioName: string;

  /**
   * @generated from field: devtool.v1.CalculationTargetType risk_calculation_target = 3;
   */
  riskCalculationTarget: CalculationTargetType;

  /**
   * @generated from field: int64 total_amount = 4;
   */
  totalAmount: bigint;
};

/**
 * Describes the message devtool.v1.TotalCreditAmountResult.
 * Use `create(TotalCreditAmountResultSchema)` to create a new message.
 */
export const TotalCreditAmountResultSchema: GenMessage<TotalCreditAmountResult> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 98);

/**
 * EvaluateMarginCall - Evaluate margin call for portfolios
 *
 * @generated from message devtool.v1.EvaluateMarginCallRequest
 */
export type EvaluateMarginCallRequest = Message<"devtool.v1.EvaluateMarginCallRequest"> & {
  /**
   * Optional: defaults to today if not specified
   *
   * @generated from field: google.type.Date ref_date = 1;
   */
  refDate?: Date;

  /**
   * Optional: specific portfolio IDs, empty = all
   *
   * @generated from field: repeated string portfolio_ids = 2;
   */
  portfolioIds: string[];

  /**
   * If true, only evaluate without saving margin call requests
   *
   * @generated from field: bool dry_run = 3;
   */
  dryRun: boolean;
};

/**
 * Describes the message devtool.v1.EvaluateMarginCallRequest.
 * Use `create(EvaluateMarginCallRequestSchema)` to create a new message.
 */
export const EvaluateMarginCallRequestSchema: GenMessage<EvaluateMarginCallRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 99);

/**
 * @generated from message devtool.v1.EvaluateMarginCallResponse
 */
export type EvaluateMarginCallResponse = Message<"devtool.v1.EvaluateMarginCallResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: google.type.Date ref_date = 2;
   */
  refDate?: Date;

  /**
   * @generated from field: repeated devtool.v1.MarginCallEvaluationDetail evaluation_details = 3;
   */
  evaluationDetails: MarginCallEvaluationDetail[];
};

/**
 * Describes the message devtool.v1.EvaluateMarginCallResponse.
 * Use `create(EvaluateMarginCallResponseSchema)` to create a new message.
 */
export const EvaluateMarginCallResponseSchema: GenMessage<EvaluateMarginCallResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 100);

/**
 * @generated from message devtool.v1.MarginCallEvaluationDetail
 */
export type MarginCallEvaluationDetail = Message<"devtool.v1.MarginCallEvaluationDetail"> & {
  /**
   * @generated from field: string portfolio_id = 1;
   */
  portfolioId: string;

  /**
   * @generated from field: string portfolio_name = 2;
   */
  portfolioName: string;

  /**
   * @generated from field: string organization_id = 3;
   */
  organizationId: string;

  /**
   * @generated from field: int64 total_credit_amount = 4;
   */
  totalCreditAmount: bigint;

  /**
   * @generated from field: int64 threshold = 5;
   */
  threshold: bigint;

  /**
   * IM
   *
   * @generated from field: int64 initial_margin = 6;
   */
  initialMargin: bigint;

  /**
   * PFE 1M 95%
   *
   * @generated from field: int64 margin_call_period_buffer = 7;
   */
  marginCallPeriodBuffer: bigint;

  /**
   * Max(MTM, 0)
   *
   * @generated from field: int64 current_collateral = 8;
   */
  currentCollateral: bigint;

  /**
   * IM + PFE + CurrentCollateral
   *
   * @generated from field: int64 required_margin = 9;
   */
  requiredMargin: bigint;

  /**
   * @generated from field: devtool.v1.MarginCallEvaluationResultType result_type = 10;
   */
  resultType: MarginCallEvaluationResultType;

  /**
   * Only set when result_type is NG
   *
   * @generated from field: int64 margin_call_amount = 11;
   */
  marginCallAmount: bigint;
};

/**
 * Describes the message devtool.v1.MarginCallEvaluationDetail.
 * Use `create(MarginCallEvaluationDetailSchema)` to create a new message.
 */
export const MarginCallEvaluationDetailSchema: GenMessage<MarginCallEvaluationDetail> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 101);

/**
 * Floating Index messages
 *
 * @generated from message devtool.v1.FloatingIndexItem
 */
export type FloatingIndexItem = Message<"devtool.v1.FloatingIndexItem"> & {
  /**
   * @generated from field: string floating_index_id = 1;
   */
  floatingIndexId: string;

  /**
   * @generated from field: string floating_index_code = 2;
   */
  floatingIndexCode: string;

  /**
   * @generated from field: bool is_active = 3;
   */
  isActive: boolean;

  /**
   * 燃調計算式
   *
   * @generated from field: string formula = 4;
   */
  formula: string;
};

/**
 * Describes the message devtool.v1.FloatingIndexItem.
 * Use `create(FloatingIndexItemSchema)` to create a new message.
 */
export const FloatingIndexItemSchema: GenMessage<FloatingIndexItem> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 102);

/**
 * @generated from message devtool.v1.UpdateFloatingIndexActiveRequest
 */
export type UpdateFloatingIndexActiveRequest = Message<"devtool.v1.UpdateFloatingIndexActiveRequest"> & {
  /**
   * @generated from field: string floating_index_id = 1;
   */
  floatingIndexId: string;

  /**
   * @generated from field: bool is_active = 2;
   */
  isActive: boolean;
};

/**
 * Describes the message devtool.v1.UpdateFloatingIndexActiveRequest.
 * Use `create(UpdateFloatingIndexActiveRequestSchema)` to create a new message.
 */
export const UpdateFloatingIndexActiveRequestSchema: GenMessage<UpdateFloatingIndexActiveRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 103);

/**
 * @generated from message devtool.v1.UpdateFloatingIndexActiveResponse
 */
export type UpdateFloatingIndexActiveResponse = Message<"devtool.v1.UpdateFloatingIndexActiveResponse"> & {
};

/**
 * Describes the message devtool.v1.UpdateFloatingIndexActiveResponse.
 * Use `create(UpdateFloatingIndexActiveResponseSchema)` to create a new message.
 */
export const UpdateFloatingIndexActiveResponseSchema: GenMessage<UpdateFloatingIndexActiveResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 104);

/**
 * Partial update request for FloatingIndex. Set only the fields you want to update.
 *
 * @generated from message devtool.v1.UpdateFloatingIndexRequest
 */
export type UpdateFloatingIndexRequest = Message<"devtool.v1.UpdateFloatingIndexRequest"> & {
  /**
   * @generated from field: string floating_index_id = 1;
   */
  floatingIndexId: string;

  /**
   * 燃調計算式
   *
   * @generated from field: optional string formula = 2;
   */
  formula?: string;
};

/**
 * Describes the message devtool.v1.UpdateFloatingIndexRequest.
 * Use `create(UpdateFloatingIndexRequestSchema)` to create a new message.
 */
export const UpdateFloatingIndexRequestSchema: GenMessage<UpdateFloatingIndexRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 105);

/**
 * @generated from message devtool.v1.UpdateFloatingIndexResponse
 */
export type UpdateFloatingIndexResponse = Message<"devtool.v1.UpdateFloatingIndexResponse"> & {
};

/**
 * Describes the message devtool.v1.UpdateFloatingIndexResponse.
 * Use `create(UpdateFloatingIndexResponseSchema)` to create a new message.
 */
export const UpdateFloatingIndexResponseSchema: GenMessage<UpdateFloatingIndexResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 106);

/**
 * @generated from message devtool.v1.CreateFloatingIndexRequest
 */
export type CreateFloatingIndexRequest = Message<"devtool.v1.CreateFloatingIndexRequest"> & {
  /**
   * 変動指標の ID。eModel に登録した定義と同じ値
   *
   * @generated from field: string floating_index_id = 1;
   */
  floatingIndexId: string;

  /**
   * コード（eModel の定義のコード）
   *
   * @generated from field: string floating_index_code = 2;
   */
  floatingIndexCode: string;

  /**
   * 名前（eModel の定義の名前）
   *
   * @generated from field: string floating_index_name = 3;
   */
  floatingIndexName: string;

  /**
   * 燃調計算式の表示（eModel が式ツリーから作った文字）
   *
   * @generated from field: string formula = 4;
   */
  formula: string;
};

/**
 * Describes the message devtool.v1.CreateFloatingIndexRequest.
 * Use `create(CreateFloatingIndexRequestSchema)` to create a new message.
 */
export const CreateFloatingIndexRequestSchema: GenMessage<CreateFloatingIndexRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 107);

/**
 * @generated from message devtool.v1.CreateFloatingIndexResponse
 */
export type CreateFloatingIndexResponse = Message<"devtool.v1.CreateFloatingIndexResponse"> & {
};

/**
 * Describes the message devtool.v1.CreateFloatingIndexResponse.
 * Use `create(CreateFloatingIndexResponseSchema)` to create a new message.
 */
export const CreateFloatingIndexResponseSchema: GenMessage<CreateFloatingIndexResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 108);

/**
 * @generated from message devtool.v1.ListFloatingIndicesRequest
 */
export type ListFloatingIndicesRequest = Message<"devtool.v1.ListFloatingIndicesRequest"> & {
};

/**
 * Describes the message devtool.v1.ListFloatingIndicesRequest.
 * Use `create(ListFloatingIndicesRequestSchema)` to create a new message.
 */
export const ListFloatingIndicesRequestSchema: GenMessage<ListFloatingIndicesRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 109);

/**
 * @generated from message devtool.v1.ListFloatingIndicesResponse
 */
export type ListFloatingIndicesResponse = Message<"devtool.v1.ListFloatingIndicesResponse"> & {
  /**
   * @generated from field: repeated devtool.v1.FloatingIndexItem items = 1;
   */
  items: FloatingIndexItem[];
};

/**
 * Describes the message devtool.v1.ListFloatingIndicesResponse.
 * Use `create(ListFloatingIndicesResponseSchema)` to create a new message.
 */
export const ListFloatingIndicesResponseSchema: GenMessage<ListFloatingIndicesResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 110);

/**
 * Floating Index Fixed Price messages
 *
 * @generated from message devtool.v1.FloatingIndexFixedPriceItem
 */
export type FloatingIndexFixedPriceItem = Message<"devtool.v1.FloatingIndexFixedPriceItem"> & {
  /**
   * @generated from field: string floating_index_id = 1;
   */
  floatingIndexId: string;

  /**
   * @generated from field: string floating_index_code = 2;
   */
  floatingIndexCode: string;

  /**
   * @generated from field: google.type.Date fixed_month = 3;
   */
  fixedMonth?: Date;

  /**
   * @generated from field: string fixed_price = 4;
   */
  fixedPrice: string;

  /**
   * @generated from field: bool is_confirmed = 5;
   */
  isConfirmed: boolean;

  /**
   * @generated from field: optional string updated_by = 6;
   */
  updatedBy?: string;
};

/**
 * Describes the message devtool.v1.FloatingIndexFixedPriceItem.
 * Use `create(FloatingIndexFixedPriceItemSchema)` to create a new message.
 */
export const FloatingIndexFixedPriceItemSchema: GenMessage<FloatingIndexFixedPriceItem> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 111);

/**
 * @generated from message devtool.v1.ListFloatingIndexFixedPricesRequest
 */
export type ListFloatingIndexFixedPricesRequest = Message<"devtool.v1.ListFloatingIndexFixedPricesRequest"> & {
};

/**
 * Describes the message devtool.v1.ListFloatingIndexFixedPricesRequest.
 * Use `create(ListFloatingIndexFixedPricesRequestSchema)` to create a new message.
 */
export const ListFloatingIndexFixedPricesRequestSchema: GenMessage<ListFloatingIndexFixedPricesRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 112);

/**
 * @generated from message devtool.v1.ListFloatingIndexFixedPricesResponse
 */
export type ListFloatingIndexFixedPricesResponse = Message<"devtool.v1.ListFloatingIndexFixedPricesResponse"> & {
  /**
   * @generated from field: repeated devtool.v1.FloatingIndexFixedPriceItem items = 1;
   */
  items: FloatingIndexFixedPriceItem[];
};

/**
 * Describes the message devtool.v1.ListFloatingIndexFixedPricesResponse.
 * Use `create(ListFloatingIndexFixedPricesResponseSchema)` to create a new message.
 */
export const ListFloatingIndexFixedPricesResponseSchema: GenMessage<ListFloatingIndexFixedPricesResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 113);

/**
 * @generated from message devtool.v1.UpdateFloatingIndexFixedPriceItem
 */
export type UpdateFloatingIndexFixedPriceItem = Message<"devtool.v1.UpdateFloatingIndexFixedPriceItem"> & {
  /**
   * @generated from field: string floating_index_id = 1;
   */
  floatingIndexId: string;

  /**
   * @generated from field: google.type.Date fixed_month = 2;
   */
  fixedMonth?: Date;

  /**
   * @generated from field: string fixed_price = 3;
   */
  fixedPrice: string;

  /**
   * @generated from field: bool is_confirmed = 4;
   */
  isConfirmed: boolean;
};

/**
 * Describes the message devtool.v1.UpdateFloatingIndexFixedPriceItem.
 * Use `create(UpdateFloatingIndexFixedPriceItemSchema)` to create a new message.
 */
export const UpdateFloatingIndexFixedPriceItemSchema: GenMessage<UpdateFloatingIndexFixedPriceItem> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 114);

/**
 * @generated from message devtool.v1.UpdateFloatingIndexFixedPricesRequest
 */
export type UpdateFloatingIndexFixedPricesRequest = Message<"devtool.v1.UpdateFloatingIndexFixedPricesRequest"> & {
  /**
   * @generated from field: repeated devtool.v1.UpdateFloatingIndexFixedPriceItem items = 1;
   */
  items: UpdateFloatingIndexFixedPriceItem[];
};

/**
 * Describes the message devtool.v1.UpdateFloatingIndexFixedPricesRequest.
 * Use `create(UpdateFloatingIndexFixedPricesRequestSchema)` to create a new message.
 */
export const UpdateFloatingIndexFixedPricesRequestSchema: GenMessage<UpdateFloatingIndexFixedPricesRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 115);

/**
 * @generated from message devtool.v1.UpdateFloatingIndexFixedPricesResponse
 */
export type UpdateFloatingIndexFixedPricesResponse = Message<"devtool.v1.UpdateFloatingIndexFixedPricesResponse"> & {
};

/**
 * Describes the message devtool.v1.UpdateFloatingIndexFixedPricesResponse.
 * Use `create(UpdateFloatingIndexFixedPricesResponseSchema)` to create a new message.
 */
export const UpdateFloatingIndexFixedPricesResponseSchema: GenMessage<UpdateFloatingIndexFixedPricesResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 116);

/**
 * EvaluateMarginCallV2 — Simulation-based margin call evaluation
 * Takes risk inputs from CheckCreditRiskResults + hedge parameters, returns full breakdown.
 *
 * @generated from message devtool.v1.EvaluateMarginCallV2Request
 */
export type EvaluateMarginCallV2Request = Message<"devtool.v1.EvaluateMarginCallV2Request"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * eClear預託金/pendingの集約単位。指定ポートフォリオに紐づく全組織のeClear残高・
   * 未承認予定を合算してポートフォリオ単位の入力にする(顧客預託金と同じ粒度)。
   *
   * @generated from field: string portfolio_id = 16;
   */
  portfolioId: string;

  /**
   * Risk inputs (from CheckCreditRiskResults)
   *
   * @generated from field: int64 max_pfe = 2;
   */
  maxPfe: bigint;

  /**
   * @generated from field: uint64 max_initial_margin = 3;
   */
  maxInitialMargin: bigint;

  /**
   * @generated from field: uint64 max_current_collateral = 4;
   */
  maxCurrentCollateral: bigint;

  /**
   * MTM (day0) — signed to support negative mark-to-market
   *
   * @generated from field: int64 mtm = 7;
   */
  mtm: bigint;

  /**
   * Hedge inputs (defaults from CheckCreditRiskResults, can override)
   *
   * deposit
   *
   * @generated from field: uint64 collateral_amount = 5;
   */
  collateralAmount: bigint;

  /**
   * threshold
   *
   * @generated from field: uint64 threshold_amount = 6;
   */
  thresholdAmount: bigint;

  /**
   * Optional overrides
   *
   * @generated from field: optional double guarantee = 10;
   */
  guarantee?: number;

  /**
   * @generated from field: optional double e_clear_deposit = 11;
   */
  eClearDeposit?: number;

  /**
   * @generated from field: optional double mta = 12;
   */
  mta?: number;

  /**
   * eClear向けMTA。未指定なら組織契約(DB)のeClearMTAを使う(顧客向けmtaと対称)。
   *
   * @generated from field: optional double eclear_mta = 17;
   */
  eclearMta?: number;

  /**
   * @generated from field: optional bool is_bilateral_override = 13;
   */
  isBilateralOverride?: boolean;

  /**
   * @generated from field: optional devtool.v1.MarginCallV2AllocationRule allocation_rule_override = 14;
   */
  allocationRuleOverride?: MarginCallV2AllocationRule;

  /**
   * 未承認(残高未反映)のeClear預託金MC予定のネット額(差入=+/返還=-)。
   * 見込み残高に加味して発行〜承認ラグ中の二重発行を防ぐ(eClear預託金MC評価のみ)。
   *
   * @generated from field: optional double pending_eclear_deposit = 15;
   */
  pendingEclearDeposit?: number;
};

/**
 * Describes the message devtool.v1.EvaluateMarginCallV2Request.
 * Use `create(EvaluateMarginCallV2RequestSchema)` to create a new message.
 */
export const EvaluateMarginCallV2RequestSchema: GenMessage<EvaluateMarginCallV2Request> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 117);

/**
 * @generated from message devtool.v1.EvaluateMarginCallV2Response
 */
export type EvaluateMarginCallV2Response = Message<"devtool.v1.EvaluateMarginCallV2Response"> & {
  /**
   * @generated from field: devtool.v1.MarginCallV2EffectiveInput effective_input = 1;
   */
  effectiveInput?: MarginCallV2EffectiveInput;

  /**
   * @generated from field: devtool.v1.MarginCallV2Breakdown breakdown = 2;
   */
  breakdown?: MarginCallV2Breakdown;

  /**
   * @generated from field: devtool.v1.MarginCallV2Decision decision = 3;
   */
  decision?: MarginCallV2Decision;

  /**
   * Organization defaults (so frontend knows what the org contract says)
   *
   * @generated from field: bool org_is_bilateral = 4;
   */
  orgIsBilateral: boolean;

  /**
   * 作成される入出金予定(口座別グロス)。VM相互差入(ネット)評価から導出
   *
   * @generated from field: repeated devtool.v1.MarginCallV2ScheduledTransaction scheduled_transactions = 5;
   */
  scheduledTransactions: MarginCallV2ScheduledTransaction[];

  /**
   * 上記予定から作成されるinvoice(プレビュー)
   *
   * @generated from field: repeated devtool.v1.MarginCallV2Invoice invoices = 6;
   */
  invoices: MarginCallV2Invoice[];
};

/**
 * Describes the message devtool.v1.EvaluateMarginCallV2Response.
 * Use `create(EvaluateMarginCallV2ResponseSchema)` to create a new message.
 */
export const EvaluateMarginCallV2ResponseSchema: GenMessage<EvaluateMarginCallV2Response> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 118);

/**
 * @generated from message devtool.v1.MarginCallV2EffectiveInput
 */
export type MarginCallV2EffectiveInput = Message<"devtool.v1.MarginCallV2EffectiveInput"> & {
  /**
   * @generated from field: double pfe = 1;
   */
  pfe: number;

  /**
   * @generated from field: double im = 2;
   */
  im: number;

  /**
   * @generated from field: double mtm_day0 = 3;
   */
  mtmDay0: number;

  /**
   * @generated from field: double deposit = 4;
   */
  deposit: number;

  /**
   * @generated from field: double guarantee = 5;
   */
  guarantee: number;

  /**
   * @generated from field: double threshold = 6;
   */
  threshold: number;

  /**
   * @generated from field: double e_clear_deposit = 7;
   */
  eClearDeposit: number;

  /**
   * @generated from field: bool is_bilateral = 8;
   */
  isBilateral: boolean;

  /**
   * @generated from field: devtool.v1.MarginCallV2AllocationRule allocation_rule = 9;
   */
  allocationRule: MarginCallV2AllocationRule;

  /**
   * @generated from field: double mta = 10;
   */
  mta: number;

  /**
   * 実際に評価へ用いたeClearMTA(DB補完後)。指定省略時は組織契約のeClearMTA。
   *
   * @generated from field: double eclear_mta = 12;
   */
  eclearMta: number;

  /**
   * 実際に評価へ用いた未承認eClear予定ネット額(DB補完後)。指定省略時は
   * ポートフォリオ単位で集約したDB値が入る。
   *
   * @generated from field: double pending_eclear_deposit = 11;
   */
  pendingEclearDeposit: number;
};

/**
 * Describes the message devtool.v1.MarginCallV2EffectiveInput.
 * Use `create(MarginCallV2EffectiveInputSchema)` to create a new message.
 */
export const MarginCallV2EffectiveInputSchema: GenMessage<MarginCallV2EffectiveInput> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 119);

/**
 * @generated from message devtool.v1.MarginCallV2Breakdown
 */
export type MarginCallV2Breakdown = Message<"devtool.v1.MarginCallV2Breakdown"> & {
  /**
   * @generated from field: double credit_support_total = 1;
   */
  creditSupportTotal: number;

  /**
   * @generated from field: double credit_support_allocated_to_vm = 2;
   */
  creditSupportAllocatedToVm: number;

  /**
   * @generated from field: double credit_support_allocated_to_im = 3;
   */
  creditSupportAllocatedToIm: number;

  /**
   * @generated from field: double required_margin = 4;
   */
  requiredMargin: number;

  /**
   * @generated from field: double current_collateral = 5;
   */
  currentCollateral: number;

  /**
   * @generated from field: double customer_surplus = 6;
   */
  customerSurplus: number;

  /**
   * @generated from field: double e_clear_surplus = 7;
   */
  eClearSurplus: number;

  /**
   * @generated from field: double excess_amount = 8;
   */
  excessAmount: number;
};

/**
 * Describes the message devtool.v1.MarginCallV2Breakdown.
 * Use `create(MarginCallV2BreakdownSchema)` to create a new message.
 */
export const MarginCallV2BreakdownSchema: GenMessage<MarginCallV2Breakdown> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 120);

/**
 * @generated from message devtool.v1.MarginCallV2Decision
 */
export type MarginCallV2Decision = Message<"devtool.v1.MarginCallV2Decision"> & {
  /**
   * @generated from field: devtool.v1.MarginCallV2Direction direction = 1;
   */
  direction: MarginCallV2Direction;

  /**
   * @generated from field: double amount = 2;
   */
  amount: number;

  /**
   * @generated from field: bool should_issue = 3;
   */
  shouldIssue: boolean;

  /**
   * @generated from field: devtool.v1.MarginCallV2AllocationRule allocation_rule = 4;
   */
  allocationRule: MarginCallV2AllocationRule;
};

/**
 * Describes the message devtool.v1.MarginCallV2Decision.
 * Use `create(MarginCallV2DecisionSchema)` to create a new message.
 */
export const MarginCallV2DecisionSchema: GenMessage<MarginCallV2Decision> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 121);

/**
 * MarginCallV2ScheduledTransaction は作成される入出金予定(口座別グロス)1件。
 *
 * @generated from message devtool.v1.MarginCallV2ScheduledTransaction
 */
export type MarginCallV2ScheduledTransaction = Message<"devtool.v1.MarginCallV2ScheduledTransaction"> & {
  /**
   * @generated from field: google.type.Date scheduled_date = 1;
   */
  scheduledDate?: Date;

  /**
   * @generated from field: uint64 amount = 2;
   */
  amount: bigint;

  /**
   * @generated from field: internalapi.v1.BankTransactionDebitCreditType debit_credit_type = 3;
   */
  debitCreditType: BankTransactionDebitCreditType;

  /**
   * @generated from field: internalapi.v1.BankTransactionUsageType usage_type = 4;
   */
  usageType: BankTransactionUsageType;
};

/**
 * Describes the message devtool.v1.MarginCallV2ScheduledTransaction.
 * Use `create(MarginCallV2ScheduledTransactionSchema)` to create a new message.
 */
export const MarginCallV2ScheduledTransactionSchema: GenMessage<MarginCallV2ScheduledTransaction> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 122);

/**
 * MarginCallV2Invoice は上記予定から作成されるinvoice(プレビュー)1件。
 *
 * @generated from message devtool.v1.MarginCallV2Invoice
 */
export type MarginCallV2Invoice = Message<"devtool.v1.MarginCallV2Invoice"> & {
  /**
   * @generated from field: google.type.Date payment_date = 1;
   */
  paymentDate?: Date;

  /**
   * @generated from field: internalapi.v1.BankTransactionDebitCreditType debit_credit_type = 2;
   */
  debitCreditType: BankTransactionDebitCreditType;

  /**
   * @generated from field: uint64 total_with_tax = 3;
   */
  totalWithTax: bigint;

  /**
   * 符号付き(Debit=+, Credit=-)の口座別内訳
   *
   * @generated from field: int64 deposit_amount = 4;
   */
  depositAmount: bigint;

  /**
   * @generated from field: int64 eclear_deposit_amount = 5;
   */
  eclearDepositAmount: bigint;
};

/**
 * Describes the message devtool.v1.MarginCallV2Invoice.
 * Use `create(MarginCallV2InvoiceSchema)` to create a new message.
 */
export const MarginCallV2InvoiceSchema: GenMessage<MarginCallV2Invoice> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 123);

/**
 * Margin Report Override messages
 *
 * @generated from message devtool.v1.UpsertMarginReportOverrideRequest
 */
export type UpsertMarginReportOverrideRequest = Message<"devtool.v1.UpsertMarginReportOverrideRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: google.type.Date reference_date = 2;
   */
  referenceDate?: Date;

  /**
   * @generated from field: bool is_hidden = 3;
   */
  isHidden: boolean;

  /**
   * @generated from field: optional int64 total_collateral_amount = 4;
   */
  totalCollateralAmount?: bigint;

  /**
   * @generated from field: optional google.type.Decimal initial_margin = 5;
   */
  initialMargin?: Decimal;

  /**
   * @generated from field: optional google.type.Decimal required_margin = 6;
   */
  requiredMargin?: Decimal;

  /**
   * @generated from field: optional google.type.Decimal realized_amount = 7;
   */
  realizedAmount?: Decimal;

  /**
   * @generated from field: optional google.type.Decimal unrealized_amount = 8;
   */
  unrealizedAmount?: Decimal;

  /**
   * @generated from field: optional bool is_margin_call_day = 9;
   */
  isMarginCallDay?: boolean;

  /**
   * @generated from field: optional string margin_report_override_id = 10;
   */
  marginReportOverrideId?: string;

  /**
   * @generated from field: optional google.type.Decimal materialized_unsettled_amount = 11;
   */
  materializedUnsettledAmount?: Decimal;

  /**
   * @generated from field: optional google.type.Decimal surplus = 12;
   */
  surplus?: Decimal;

  /**
   * @generated from field: optional int64 performance_guarantee = 13;
   */
  performanceGuarantee?: bigint;

  /**
   * @generated from field: optional int64 guarantee_issuance_limit = 14;
   */
  guaranteeIssuanceLimit?: bigint;
};

/**
 * Describes the message devtool.v1.UpsertMarginReportOverrideRequest.
 * Use `create(UpsertMarginReportOverrideRequestSchema)` to create a new message.
 */
export const UpsertMarginReportOverrideRequestSchema: GenMessage<UpsertMarginReportOverrideRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 124);

/**
 * @generated from message devtool.v1.UpsertMarginReportOverrideResponse
 */
export type UpsertMarginReportOverrideResponse = Message<"devtool.v1.UpsertMarginReportOverrideResponse"> & {
};

/**
 * Describes the message devtool.v1.UpsertMarginReportOverrideResponse.
 * Use `create(UpsertMarginReportOverrideResponseSchema)` to create a new message.
 */
export const UpsertMarginReportOverrideResponseSchema: GenMessage<UpsertMarginReportOverrideResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 125);

/**
 * @generated from message devtool.v1.DeleteMarginReportOverrideRequest
 */
export type DeleteMarginReportOverrideRequest = Message<"devtool.v1.DeleteMarginReportOverrideRequest"> & {
  /**
   * @generated from field: string margin_report_override_id = 1;
   */
  marginReportOverrideId: string;
};

/**
 * Describes the message devtool.v1.DeleteMarginReportOverrideRequest.
 * Use `create(DeleteMarginReportOverrideRequestSchema)` to create a new message.
 */
export const DeleteMarginReportOverrideRequestSchema: GenMessage<DeleteMarginReportOverrideRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 126);

/**
 * @generated from message devtool.v1.DeleteMarginReportOverrideResponse
 */
export type DeleteMarginReportOverrideResponse = Message<"devtool.v1.DeleteMarginReportOverrideResponse"> & {
};

/**
 * Describes the message devtool.v1.DeleteMarginReportOverrideResponse.
 * Use `create(DeleteMarginReportOverrideResponseSchema)` to create a new message.
 */
export const DeleteMarginReportOverrideResponseSchema: GenMessage<DeleteMarginReportOverrideResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 127);

/**
 * @generated from message devtool.v1.BuildLiquidityPFEBookRequest
 */
export type BuildLiquidityPFEBookRequest = Message<"devtool.v1.BuildLiquidityPFEBookRequest"> & {
  /**
   * 基準日。バッチの夜間実行と同じく基準日 18:00 JST 時点のスナップショット（取引・入出金予定）で
   * book を組む。ただし締めがまだ来ていない当日は現在時刻のスナップショット（実際の時刻は
   * response の as_of_time）。将来日は INVALID_ARGUMENT。
   * 預託金残高と契約・ポートフォリオのマスタは実行時点の値（バッチと同じ制約）。
   *
   * @generated from field: google.type.Date base_date = 1;
   */
  baseDate?: Date;

  /**
   * 載せる取引の範囲。UNSPECIFIED = 全社（バッチと同じ）。どの範囲でも、eClear posting が NG（REJECTED）・
   * 取消（CANCELED）の約定は載せない（バッチも同じ）。posting 中（PROCESSING）と posting 行の無い約定は載せる。
   * 範囲で取引を絞っても、預託金・IM・cashIO・保証枠はポートフォリオ全額のまま。
   *
   * @generated from field: devtool.v1.LiquidityBookScope scope = 2;
   */
  scope: LiquidityBookScope;
};

/**
 * Describes the message devtool.v1.BuildLiquidityPFEBookRequest.
 * Use `create(BuildLiquidityPFEBookRequestSchema)` to create a new message.
 */
export const BuildLiquidityPFEBookRequestSchema: GenMessage<BuildLiquidityPFEBookRequest> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 128);

/**
 * @generated from message devtool.v1.BuildLiquidityPFEBookResponse
 */
export type BuildLiquidityPFEBookResponse = Message<"devtool.v1.BuildLiquidityPFEBookResponse"> & {
  /**
   * 全 counterparty の評価日数の最大（バッチのリクエストの evaluation_days・horizons に使う値）。
   *
   * @generated from field: int32 evaluation_days = 1;
   */
  evaluationDays: number;

  /**
   * バッチが CalculateLiquidityPFE に載せる counterparty そのもの（加工しない）。
   *
   * @generated from field: repeated devtool.emodel.v1.LiquidityCounterparty counterparties = 2;
   */
  counterparties: LiquidityCounterparty[];

  /**
   * 表示用のラベル。counterparties と同じ並び（index で対応）。
   *
   * @generated from field: repeated devtool.v1.LiquidityPFEBookEntry entries = 3;
   */
  entries: LiquidityPFEBookEntry[];

  /**
   * book のスナップショット時刻。基準日 18:00 JST、ただし締めがまだ来ていない当日は現在時刻。
   *
   * @generated from field: google.protobuf.Timestamp as_of_time = 4;
   */
  asOfTime?: Timestamp;

  /**
   * book から外したポートフォリオと理由（契約なし・基準日に有効な契約の区分なし・約定の明細なし・NG・取消のみ 等）。
   * 範囲（scope）の外のポートフォリオは載せない。並びはポートフォリオ ID 順。
   *
   * @generated from field: repeated devtool.v1.LiquidityBookSkipReason skip_reasons = 5;
   */
  skipReasons: LiquidityBookSkipReason[];
};

/**
 * Describes the message devtool.v1.BuildLiquidityPFEBookResponse.
 * Use `create(BuildLiquidityPFEBookResponseSchema)` to create a new message.
 */
export const BuildLiquidityPFEBookResponseSchema: GenMessage<BuildLiquidityPFEBookResponse> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 129);

/**
 * LiquidityBookSkipReason は book から外したポートフォリオ 1 件。
 *
 * @generated from message devtool.v1.LiquidityBookSkipReason
 */
export type LiquidityBookSkipReason = Message<"devtool.v1.LiquidityBookSkipReason"> & {
  /**
   * 外したポートフォリオの ID。
   *
   * @generated from field: string portfolio_id = 1;
   */
  portfolioId: string;

  /**
   * ポートフォリオ名 + 代表組織名（表示専用。名前が引けなければ ID）。entries の label と同じ作り方。
   *
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * 外した理由（表示用の短い文言）。
   *
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * Describes the message devtool.v1.LiquidityBookSkipReason.
 * Use `create(LiquidityBookSkipReasonSchema)` to create a new message.
 */
export const LiquidityBookSkipReasonSchema: GenMessage<LiquidityBookSkipReason> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 130);

/**
 * LiquidityPFEBookEntry は book の counterparty 1 件の表示用情報。
 *
 * @generated from message devtool.v1.LiquidityPFEBookEntry
 */
export type LiquidityPFEBookEntry = Message<"devtool.v1.LiquidityPFEBookEntry"> & {
  /**
   * counterparties[i].counterparty_id と同じ値（ポートフォリオ ID または "EEX/KGI" 等）。
   *
   * @generated from field: string counterparty_id = 1;
   */
  counterpartyId: string;

  /**
   * ポートフォリオ名 + 代表組織名（表示専用。名前が引けなければ ID）。EEX は合成 ID そのもの。
   *
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * ポートフォリオに属する組織（表示専用。並びは保証しない）。EEX は空。
   *
   * @generated from field: repeated string organization_ids = 3;
   */
  organizationIds: string[];

  /**
   * ネット前の取引（編集の初期値）。ポートフォリオは preparer に渡した取引（scope・NG/取消の除外・与信軸の Pick の後）、
   * EEX は counterparties[i].raw_trade_data.transactions と同じ集合。
   *
   * @generated from field: repeated devtool.v1.LiquidityBookTransaction transactions = 4;
   */
  transactions: LiquidityBookTransaction[];

  /**
   * 品代の支払日ルール（PreparePFERequestRequest.payment_timing_override と同じ型）。先頭組織の契約のうち、
   * 基準日を含む期間のルール。reconcile（預託金から精算）の組織は月末最終営業日。基準日を含む期間が無い・
   * 上書きで表せない種別・EEX は未設定で、理由を payment_rule_note に入れる。基準日の期間の後で契約のルールが
   * 切り替わるときは、ルールを入れたうえで payment_rule_note にもその旨を入れる。
   *
   * @generated from field: optional devtool.v1.PFEPaymentTimingOverride payment_rule = 5;
   */
  paymentRule?: PFEPaymentTimingOverride;

  /**
   * payment_rule を未設定にした理由、または payment_rule が 1 ルールで契約を表しきれない理由（期間で切り替わる）。
   *
   * @generated from field: optional string payment_rule_note = 6;
   */
  paymentRuleNote?: string;

  /**
   * 入出金予定（fetcher が作った日次 cashIO を、response の evaluation_days まで 0 で埋めて日ごとの差分にしたもの）。
   * response の evaluation_days で PreparePFERequestRequest.cash_io_schedules に送り直すと、バッチが送る日次配列
   * （この counterparty 自身の窓の後は 0）に戻る。窓の終わりの翌日に残高を打ち消す入出金が入るのはこの 0 埋めの結果で、
   * 実際の予定ではない。差分 0 の日は載せない。evaluation_days の外は返さない。EEX は空。
   *
   * @generated from field: repeated devtool.v1.PFECashIOEntry cash_io_schedules = 7;
   */
  cashIoSchedules: PFECashIOEntry[];
};

/**
 * Describes the message devtool.v1.LiquidityPFEBookEntry.
 * Use `create(LiquidityPFEBookEntrySchema)` to create a new message.
 */
export const LiquidityPFEBookEntrySchema: GenMessage<LiquidityPFEBookEntry> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 131);

/**
 * LiquidityBookTransaction は book に載せた取引 1 件（dev-tool の編集用。顧客の氏名・連絡先・月別 kWh は載せない）。
 *
 * @generated from message devtool.v1.LiquidityBookTransaction
 */
export type LiquidityBookTransaction = Message<"devtool.v1.LiquidityBookTransaction"> & {
  /**
   * deal の表示コード（eClear の約定コード。無ければ platform の deal ID）。
   *
   * @generated from field: string deal_code = 1;
   */
  dealCode: string;

  /**
   * 約定日時。
   *
   * @generated from field: google.protobuf.Timestamp dealt_at = 2;
   */
  dealtAt?: Timestamp;

  /**
   * 買い/売り（顧客側の向き。eClear はこの逆）。
   *
   * @generated from field: types.v1.DealPosition deal_position = 3;
   */
  dealPosition: DealPosition;

  /**
   * 受渡エリア。
   *
   * @generated from field: types.v1.AreaCode area_code = 4;
   */
  areaCode: AreaCode;

  /**
   * 時間帯区分。
   *
   * @generated from field: types.v1.DeliveryHourType delivery_hour_type = 5;
   */
  deliveryHourType: DeliveryHourType;

  /**
   * 受給期間区分。
   *
   * @generated from field: types.v1.DeliveryPeriodType delivery_period_type = 6;
   */
  deliveryPeriodType: DeliveryPeriodType;

  /**
   * 商品区分（BG渡し / JEPX渡し / EEX）。
   *
   * @generated from field: types.v1.DeliveryType delivery_type = 7;
   */
  deliveryType: DeliveryType;

  /**
   * eClear が用いる商品区分（現先の現物レグは EEX）。
   *
   * @generated from field: types.v1.DeliveryType eclear_delivery_type = 8;
   */
  eclearDeliveryType: DeliveryType;

  /**
   * 受給期間の開始日時（休日等を無視した商品自体の期間）。
   *
   * @generated from field: google.protobuf.Timestamp delivery_start_at = 9;
   */
  deliveryStartAt?: Timestamp;

  /**
   * 受給期間の終了日時（排他。external.v1.Transaction.delivery_end_at と同じ規約）。
   *
   * @generated from field: google.protobuf.Timestamp delivery_end_at = 10;
   */
  deliveryEndAt?: Timestamp;

  /**
   * 取引量（kW）。
   *
   * @generated from field: int64 volume_in_kw = 11 [jstype = JS_STRING];
   */
  volumeInKw: string;

  /**
   * 1kWh あたりの単価（円）。
   *
   * @generated from field: google.type.Decimal unit_price_per_kwh = 12;
   */
  unitPricePerKwh?: Decimal;

  /**
   * 変動指標コード。変動価格付き取引のときだけ設定。
   *
   * @generated from field: optional string floating_index_code = 13;
   */
  floatingIndexCode?: string;

  /**
   * どこまで清算済みかを表す日付。未設定は全期間が未清算。
   *
   * @generated from field: optional google.type.Date settled_until = 14;
   */
  settledUntil?: Date;

  /**
   * 差額精算対象エリア。deal に焼き込まれているときだけ設定。
   *
   * @generated from field: optional types.v1.AreaCode settlement_difference_target_area_code = 15;
   */
  settlementDifferenceTargetAreaCode?: AreaCode;

  /**
   * 約定明細の ID。
   *
   * @generated from field: string deal_transaction_id = 16;
   */
  dealTransactionId: string;
};

/**
 * Describes the message devtool.v1.LiquidityBookTransaction.
 * Use `create(LiquidityBookTransactionSchema)` to create a new message.
 */
export const LiquidityBookTransactionSchema: GenMessage<LiquidityBookTransaction> = /*@__PURE__*/
  messageDesc(file_devtool_v1_service, 132);

/**
 * バッファ適用モード
 *
 * @generated from enum devtool.v1.UnitPriceBufferMode
 */
export enum UnitPriceBufferMode {
  /**
   * @generated from enum value: UNIT_PRICE_BUFFER_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 日中用: 新規注文のみにバッファ適用
   *
   * @generated from enum value: UNIT_PRICE_BUFFER_MODE_NEW_ORDERS_ONLY = 1;
   */
  NEW_ORDERS_ONLY = 1,

  /**
   * リーブオーダー用: 新規+既存すべてにバッファ適用
   *
   * @generated from enum value: UNIT_PRICE_BUFFER_MODE_ALL_TRANSACTIONS = 2;
   */
  ALL_TRANSACTIONS = 2,
}

/**
 * Describes the enum devtool.v1.UnitPriceBufferMode.
 */
export const UnitPriceBufferModeSchema: GenEnum<UnitPriceBufferMode> = /*@__PURE__*/
  enumDesc(file_devtool_v1_service, 0);

/**
 * @generated from enum devtool.v1.CalculationTargetType
 */
export enum CalculationTargetType {
  /**
   * @generated from enum value: CALCULATION_TARGET_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * All
   *
   * @generated from enum value: CALCULATION_TARGET_TYPE_ALL = 1;
   */
  ALL = 1,

  /**
   * Physical Futures
   *
   * @generated from enum value: CALCULATION_TARGET_TYPE_PHYSICAL_FUTURES = 2;
   */
  PHYSICAL_FUTURES = 2,
}

/**
 * Describes the enum devtool.v1.CalculationTargetType.
 */
export const CalculationTargetTypeSchema: GenEnum<CalculationTargetType> = /*@__PURE__*/
  enumDesc(file_devtool_v1_service, 1);

/**
 * @generated from enum devtool.v1.SchemeType
 */
export enum SchemeType {
  /**
   * not specified
   *
   * @generated from enum value: SCHEME_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Option1
   *
   * @generated from enum value: SCHEME_TYPE_OPTION1 = 1;
   */
  OPTION1 = 1,

  /**
   * Option2
   *
   * @generated from enum value: SCHEME_TYPE_OPTION2 = 2;
   */
  OPTION2 = 2,
}

/**
 * Describes the enum devtool.v1.SchemeType.
 */
export const SchemeTypeSchema: GenEnum<SchemeType> = /*@__PURE__*/
  enumDesc(file_devtool_v1_service, 2);

/**
 * Job status enum for bulk simulation
 *
 * @generated from enum devtool.v1.BulkSimulationJobStatus
 */
export enum BulkSimulationJobStatus {
  /**
   * @generated from enum value: BULK_SIMULATION_JOB_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BULK_SIMULATION_JOB_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: BULK_SIMULATION_JOB_STATUS_PROCESSING = 2;
   */
  PROCESSING = 2,

  /**
   * @generated from enum value: BULK_SIMULATION_JOB_STATUS_COMPLETED = 3;
   */
  COMPLETED = 3,

  /**
   * @generated from enum value: BULK_SIMULATION_JOB_STATUS_FAILED = 4;
   */
  FAILED = 4,

  /**
   * @generated from enum value: BULK_SIMULATION_JOB_STATUS_CANCELLED = 5;
   */
  CANCELLED = 5,
}

/**
 * Describes the enum devtool.v1.BulkSimulationJobStatus.
 */
export const BulkSimulationJobStatusSchema: GenEnum<BulkSimulationJobStatus> = /*@__PURE__*/
  enumDesc(file_devtool_v1_service, 3);

/**
 * @generated from enum devtool.v1.MarginCallEvaluationResultType
 */
export enum MarginCallEvaluationResultType {
  /**
   * @generated from enum value: MARGIN_CALL_EVALUATION_RESULT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MARGIN_CALL_EVALUATION_RESULT_TYPE_OK = 1;
   */
  OK = 1,

  /**
   * @generated from enum value: MARGIN_CALL_EVALUATION_RESULT_TYPE_NG = 2;
   */
  NG = 2,
}

/**
 * Describes the enum devtool.v1.MarginCallEvaluationResultType.
 */
export const MarginCallEvaluationResultTypeSchema: GenEnum<MarginCallEvaluationResultType> = /*@__PURE__*/
  enumDesc(file_devtool_v1_service, 4);

/**
 * @generated from enum devtool.v1.MarginCallV2Direction
 */
export enum MarginCallV2Direction {
  /**
   * @generated from enum value: MARGIN_CALL_V2_DIRECTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MARGIN_CALL_V2_DIRECTION_RECEIVE = 1;
   */
  RECEIVE = 1,

  /**
   * @generated from enum value: MARGIN_CALL_V2_DIRECTION_PAY = 2;
   */
  PAY = 2,
}

/**
 * Describes the enum devtool.v1.MarginCallV2Direction.
 */
export const MarginCallV2DirectionSchema: GenEnum<MarginCallV2Direction> = /*@__PURE__*/
  enumDesc(file_devtool_v1_service, 5);

/**
 * @generated from enum devtool.v1.MarginCallV2AllocationRule
 */
export enum MarginCallV2AllocationRule {
  /**
   * @generated from enum value: MARGIN_CALL_V2_ALLOCATION_RULE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MARGIN_CALL_V2_ALLOCATION_RULE_POOLED = 1;
   */
  POOLED = 1,

  /**
   * @generated from enum value: MARGIN_CALL_V2_ALLOCATION_RULE_SEPARATED = 2;
   */
  SEPARATED = 2,
}

/**
 * Describes the enum devtool.v1.MarginCallV2AllocationRule.
 */
export const MarginCallV2AllocationRuleSchema: GenEnum<MarginCallV2AllocationRule> = /*@__PURE__*/
  enumDesc(file_devtool_v1_service, 6);

/**
 * LiquidityBookScope は BuildLiquidityPFEBook に載せる取引の範囲。
 *
 * @generated from enum devtool.v1.LiquidityBookScope
 */
export enum LiquidityBookScope {
  /**
   * 全社（今のバッチと同じ）。
   *
   * @generated from enum value: LIQUIDITY_BOOK_SCOPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * VM 相互差し入れ関連: いずれかの組織が相互差入契約（is_bilateral_vm_exchange）のポートフォリオを丸ごと
   * （現現・現先）と、現物側のいずれかの組織がそのポートフォリオに属する現先 deal の EEX レグ。
   *
   * @generated from enum value: LIQUIDITY_BOOK_SCOPE_BILATERAL_VM = 1;
   */
  BILATERAL_VM = 1,

  /**
   * 先物関連: 現先 deal だけ。個社 counterparty には現物レグ、EEX 合成 counterparty には EEX レグ。
   * 現先の取引が 0 件になったポートフォリオは skip する。
   *
   * @generated from enum value: LIQUIDITY_BOOK_SCOPE_PHYSICAL_FUTURES = 2;
   */
  PHYSICAL_FUTURES = 2,
}

/**
 * Describes the enum devtool.v1.LiquidityBookScope.
 */
export const LiquidityBookScopeSchema: GenEnum<LiquidityBookScope> = /*@__PURE__*/
  enumDesc(file_devtool_v1_service, 7);

/**
 * @generated from service devtool.v1.DevToolService
 */
export const DevToolService: GenService<{
  /**
   * @generated from rpc devtool.v1.DevToolService.HealthCheck
   */
  healthCheck: {
    methodKind: "unary";
    input: typeof HealthCheckRequestSchema;
    output: typeof HealthCheckResponseSchema;
  },
  /**
   * @generated from rpc devtool.v1.DevToolService.CalculateLiquidityPFEFromPortfolios
   */
  calculateLiquidityPFEFromPortfolios: {
    methodKind: "unary";
    input: typeof CalculateLiquidityPFEFromPortfoliosRequestSchema;
    output: typeof CalculateLiquidityPFEFromPortfoliosResponseSchema;
  },
  /**
   * @generated from rpc devtool.v1.DevToolService.GetPortfolioMTM
   */
  getPortfolioMTM: {
    methodKind: "unary";
    input: typeof GetPortfolioMTMRequestSchema;
    output: typeof GetPortfolioMTMResponseSchema;
  },
  /**
   * @generated from rpc devtool.v1.DevToolService.StoreDealForDevTool
   */
  storeDealForDevTool: {
    methodKind: "unary";
    input: typeof StoreDealForDevToolRequestSchema;
    output: typeof StoreDealForDevToolResponseSchema;
  },
  /**
   * @generated from rpc devtool.v1.DevToolService.ExecuteRawSQL
   */
  executeRawSQL: {
    methodKind: "unary";
    input: typeof ExecuteRawSQLRequestSchema;
    output: typeof ExecuteRawSQLResponseSchema;
  },
  /**
   * @generated from rpc devtool.v1.DevToolService.GetDealForDevTool
   */
  getDealForDevTool: {
    methodKind: "unary";
    input: typeof GetDealForDevToolRequestSchema;
    output: typeof GetDealForDevToolResponseSchema;
  },
  /**
   * @generated from rpc devtool.v1.DevToolService.SimulatePFEByOrder
   */
  simulatePFEByOrder: {
    methodKind: "unary";
    input: typeof SimulatePFEByOrderRequestSchema;
    output: typeof SimulatePFEByOrderResponseSchema;
  },
  /**
   * @generated from rpc devtool.v1.DevToolService.BulkSimulatePFEByOrderCSV
   */
  bulkSimulatePFEByOrderCSV: {
    methodKind: "unary";
    input: typeof BulkSimulatePFEByOrderCSVRequestSchema;
    output: typeof BulkSimulatePFEByOrderCSVResponseSchema;
  },
  /**
   * buf:lint:ignore RPC_REQUEST_STANDARD_NAME
   *
   * @generated from rpc devtool.v1.DevToolService.BulkSimulatePFEByOrderCSVStream
   */
  bulkSimulatePFEByOrderCSVStream: {
    methodKind: "server_streaming";
    input: typeof BulkSimulatePFEByOrderCSVRequestSchema;
    output: typeof BulkSimulatePFEByOrderCSVStreamResponseSchema;
  },
  /**
   * Deposit operations (dev only)
   *
   * @generated from rpc devtool.v1.DevToolService.GetOrganizationDeposits
   */
  getOrganizationDeposits: {
    methodKind: "unary";
    input: typeof GetOrganizationDepositsRequestSchema;
    output: typeof GetOrganizationDepositsResponseSchema;
  },
  /**
   * @generated from rpc devtool.v1.DevToolService.ModifyOrganizationDeposit
   */
  modifyOrganizationDeposit: {
    methodKind: "unary";
    input: typeof ModifyOrganizationDepositRequestSchema;
    output: typeof ModifyOrganizationDepositResponseSchema;
  },
  /**
   * Bank scheduled transaction operations
   *
   * @generated from rpc devtool.v1.DevToolService.GetBankScheduledTransactions
   */
  getBankScheduledTransactions: {
    methodKind: "unary";
    input: typeof GetBankScheduledTransactionsRequestSchema;
    output: typeof GetBankScheduledTransactionsResponseSchema;
  },
  /**
   * Job result operations
   *
   * @generated from rpc devtool.v1.DevToolService.ListJobResults
   */
  listJobResults: {
    methodKind: "unary";
    input: typeof ListJobResultsRequestSchema;
    output: typeof ListJobResultsResponseSchema;
  },
  /**
   * @generated from rpc devtool.v1.DevToolService.GetJobResult
   */
  getJobResult: {
    methodKind: "unary";
    input: typeof GetJobResultRequestSchema;
    output: typeof GetJobResultResponseSchema;
  },
  /**
   * Organization contract operations (proxied from admin service with enhanced response)
   *
   * @generated from rpc devtool.v1.DevToolService.ListOrganizationContracts
   */
  listOrganizationContracts: {
    methodKind: "unary";
    input: typeof ListOrganizationContractsRequestSchema;
    output: typeof DevToolServiceListOrganizationContractsResponseSchema;
  },
  /**
   * Organization member operations (for posting-simulator)
   *
   * @generated from rpc devtool.v1.DevToolService.ListMembers
   */
  listMembers: {
    methodKind: "unary";
    input: typeof ListMembersRequestSchema;
    output: typeof ListMembersResponseSchema;
  },
  /**
   * EEX operations (for posting-simulator)
   *
   * @generated from rpc devtool.v1.DevToolService.ListClearingAccounts
   */
  listClearingAccounts: {
    methodKind: "unary";
    input: typeof ListClearingAccountsRequestSchema;
    output: typeof ListClearingAccountsResponseSchema;
  },
  /**
   * @generated from rpc devtool.v1.DevToolService.ListTraders
   */
  listTraders: {
    methodKind: "unary";
    input: typeof ListTradersRequestSchema;
    output: typeof ListTradersResponseSchema;
  },
  /**
   * @generated from rpc devtool.v1.DevToolService.DebugFeatureFlag
   */
  debugFeatureFlag: {
    methodKind: "unary";
    input: typeof DebugFeatureFlagRequestSchema;
    output: typeof DebugFeatureFlagResponseSchema;
  },
  /**
   * Time operations
   *
   * @generated from rpc devtool.v1.DevToolService.GetCurrentTime
   */
  getCurrentTime: {
    methodKind: "unary";
    input: typeof GetCurrentTimeRequestSchema;
    output: typeof GetCurrentTimeResponseSchema;
  },
  /**
   * Deal archiving operation (dev tool only)
   *
   * @generated from rpc devtool.v1.DevToolService.ArchiveDeal
   */
  archiveDeal: {
    methodKind: "unary";
    input: typeof ArchiveDealRequestSchema;
    output: typeof ArchiveDealResponseSchema;
  },
  /**
   * Deal change operation (dev tool only) - split/change deals in a single transaction
   *
   * @generated from rpc devtool.v1.DevToolService.ChangeDeal
   */
  changeDeal: {
    methodKind: "unary";
    input: typeof ChangeDealRequestSchema;
    output: typeof ChangeDealResponseSchema;
  },
  /**
   * DevTool user setting operations
   *
   * @generated from rpc devtool.v1.DevToolService.GetDevToolUserSetting
   */
  getDevToolUserSetting: {
    methodKind: "unary";
    input: typeof GetDevToolUserSettingRequestSchema;
    output: typeof GetDevToolUserSettingResponseSchema;
  },
  /**
   * @generated from rpc devtool.v1.DevToolService.UpdateDevToolUserSetting
   */
  updateDevToolUserSetting: {
    methodKind: "unary";
    input: typeof UpdateDevToolUserSettingRequestSchema;
    output: typeof UpdateDevToolUserSettingResponseSchema;
  },
  /**
   * Batch Bulk Simulation APIs (async processing with polling)
   *
   * @generated from rpc devtool.v1.DevToolService.StartBulkSimulation
   */
  startBulkSimulation: {
    methodKind: "unary";
    input: typeof StartBulkSimulationRequestSchema;
    output: typeof StartBulkSimulationResponseSchema;
  },
  /**
   * @generated from rpc devtool.v1.DevToolService.GetBulkSimulationStatus
   */
  getBulkSimulationStatus: {
    methodKind: "unary";
    input: typeof GetBulkSimulationStatusRequestSchema;
    output: typeof GetBulkSimulationStatusResponseSchema;
  },
  /**
   * @generated from rpc devtool.v1.DevToolService.GetBulkSimulationResult
   */
  getBulkSimulationResult: {
    methodKind: "unary";
    input: typeof GetBulkSimulationResultRequestSchema;
    output: typeof GetBulkSimulationResultResponseSchema;
  },
  /**
   * Margin Call operations (dev tool only)
   *
   * @generated from rpc devtool.v1.DevToolService.ListTotalCreditAmounts
   */
  listTotalCreditAmounts: {
    methodKind: "unary";
    input: typeof ListTotalCreditAmountsRequestSchema;
    output: typeof ListTotalCreditAmountsResponseSchema;
  },
  /**
   * @generated from rpc devtool.v1.DevToolService.CalculateTotalCreditAmount
   */
  calculateTotalCreditAmount: {
    methodKind: "unary";
    input: typeof CalculateTotalCreditAmountRequestSchema;
    output: typeof CalculateTotalCreditAmountResponseSchema;
  },
  /**
   * @generated from rpc devtool.v1.DevToolService.EvaluateMarginCall
   */
  evaluateMarginCall: {
    methodKind: "unary";
    input: typeof EvaluateMarginCallRequestSchema;
    output: typeof EvaluateMarginCallResponseSchema;
  },
  /**
   * @generated from rpc devtool.v1.DevToolService.EvaluateMarginCallV2
   */
  evaluateMarginCallV2: {
    methodKind: "unary";
    input: typeof EvaluateMarginCallV2RequestSchema;
    output: typeof EvaluateMarginCallV2ResponseSchema;
  },
  /**
   * Floating Index operations
   *
   * @generated from rpc devtool.v1.DevToolService.ListFloatingIndices
   */
  listFloatingIndices: {
    methodKind: "unary";
    input: typeof ListFloatingIndicesRequestSchema;
    output: typeof ListFloatingIndicesResponseSchema;
  },
  /**
   * @generated from rpc devtool.v1.DevToolService.UpdateFloatingIndexActive
   */
  updateFloatingIndexActive: {
    methodKind: "unary";
    input: typeof UpdateFloatingIndexActiveRequestSchema;
    output: typeof UpdateFloatingIndexActiveResponseSchema;
  },
  /**
   * Partial update for floating index. Only fields that are explicitly set will be updated.
   *
   * @generated from rpc devtool.v1.DevToolService.UpdateFloatingIndex
   */
  updateFloatingIndex: {
    methodKind: "unary";
    input: typeof UpdateFloatingIndexRequestSchema;
    output: typeof UpdateFloatingIndexResponseSchema;
  },
  /**
   * Creates ePosition's floating index row for an index registered in eModel, with the same ID.
   * A row with the same ID and the same code is left as is and the call succeeds, so a retry after a partial
   * failure completes the registration. The name and the formula are not compared: eModel refuses another content
   * under the same ID, and the formula is display text eModel draws from the expression.
   * ALREADY_EXISTS when the row with the same ID has another code, or another row has the same code.
   *
   * @generated from rpc devtool.v1.DevToolService.CreateFloatingIndex
   */
  createFloatingIndex: {
    methodKind: "unary";
    input: typeof CreateFloatingIndexRequestSchema;
    output: typeof CreateFloatingIndexResponseSchema;
  },
  /**
   * Floating Index Fixed Price operations
   *
   * @generated from rpc devtool.v1.DevToolService.ListFloatingIndexFixedPrices
   */
  listFloatingIndexFixedPrices: {
    methodKind: "unary";
    input: typeof ListFloatingIndexFixedPricesRequestSchema;
    output: typeof ListFloatingIndexFixedPricesResponseSchema;
  },
  /**
   * @generated from rpc devtool.v1.DevToolService.UpdateFloatingIndexFixedPrices
   */
  updateFloatingIndexFixedPrices: {
    methodKind: "unary";
    input: typeof UpdateFloatingIndexFixedPricesRequestSchema;
    output: typeof UpdateFloatingIndexFixedPricesResponseSchema;
  },
  /**
   * Margin Report Override operations (dev tool only)
   *
   * @generated from rpc devtool.v1.DevToolService.UpsertMarginReportOverride
   */
  upsertMarginReportOverride: {
    methodKind: "unary";
    input: typeof UpsertMarginReportOverrideRequestSchema;
    output: typeof UpsertMarginReportOverrideResponseSchema;
  },
  /**
   * @generated from rpc devtool.v1.DevToolService.DeleteMarginReportOverride
   */
  deleteMarginReportOverride: {
    methodKind: "unary";
    input: typeof DeleteMarginReportOverrideRequestSchema;
    output: typeof DeleteMarginReportOverrideResponseSchema;
  },
  /**
   * Thin proxy for eModel's CalculatePowerMTM. The MTM Calculator UI
   * assembles the position list (manually, by importing a portfolio's
   * deals, or both) and calls this RPC; the backend just forwards.
   *
   * @generated from rpc devtool.v1.DevToolService.CalculatePowerMTM
   */
  calculatePowerMTM: {
    methodKind: "unary";
    input: typeof CalculatePowerMTMRequestSchema;
    output: typeof CalculatePowerMTMResponseSchema;
  },
  /**
   * Assembles a raw_trade_data CalculateRiskRequest from a portfolio's deals
   * and organization settings WITHOUT running any PFE simulation. Used by the
   * dev-tool PFE Simulator to prefill an editable request.
   * buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
   *
   * @generated from rpc devtool.v1.DevToolService.PreparePFERequest
   */
  preparePFERequest: {
    methodKind: "unary";
    input: typeof PreparePFERequestRequestSchema;
    output: typeof CalculateRiskRequestSchema;
  },
  /**
   * Assembles the request (same as PreparePFERequest) AND runs eModel's PFE,
   * all server-side. The dev-tool PFE Simulator uses this so the eModel call
   * and any backend-computed inputs (e.g. daily_mtms) stay on the backend.
   * buf:lint:ignore RPC_REQUEST_STANDARD_NAME
   * buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
   *
   * @generated from rpc devtool.v1.DevToolService.SimulatePFE
   */
  simulatePFE: {
    methodKind: "unary";
    input: typeof PreparePFERequestRequestSchema;
    output: typeof CalculateRiskResponseSchema;
  },
  /**
   * Returns the collateral baseline (current collateral from MTM, margin-call
   * threshold + scheduled cash flows from the organization contract) to
   * prefill the PFE Simulator's collateral section on import.
   *
   * @generated from rpc devtool.v1.DevToolService.PreparePFECollateral
   */
  preparePFECollateral: {
    methodKind: "unary";
    input: typeof PreparePFECollateralRequestSchema;
    output: typeof PreparePFECollateralResponseSchema;
  },
  /**
   * 全社流動性PFE の EOD バッチと同じ book（ポートフォリオ単位の counterparty +
   * clearer 別の EEX）を組み立てて返す。eModel は呼ばない。dev-tool の
   * Liquidity PFE Simulator の「全社 Import」が、バッチと同じ入力をそのまま
   * CalculateLiquidityPFE に送るために使う。
   *
   * @generated from rpc devtool.v1.DevToolService.BuildLiquidityPFEBook
   */
  buildLiquidityPFEBook: {
    methodKind: "unary";
    input: typeof BuildLiquidityPFEBookRequestSchema;
    output: typeof BuildLiquidityPFEBookResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_devtool_v1_service, 0);

